//import { modelvales } from "assets/3d-model.js";

var hasUid = false;
var hasMeasurementType = false;
// var optionsArr = [
//   {
//     "buttoning": "single_breasted_2_button",
//     "lapel_style": "notch",
//     "lapel_width": "mid",
//     "shoulder": "natural_shoulder_-_structured_(5_mm)",
//     "chest_pocket": "boat",
//     "side_pocket": "flap",
//     "ticket_pocket": "yes",
//     "buttons": "horn_mahogany_mid_brown_(H010068)",
//     "lining": "fully_lined",
//     "lining_colour": "light_grey"
//   }
// ]

var Shopify = Shopify || {};
var selectedCountry = Shopify.country;
Shopify.money_format = window.shopMoneyFormat;
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function moveMarker() {
  var activeNav = $('.cm-toggle-item.isSelected');
  var activewidth = $(activeNav).width();
  var activePadLeft = parseFloat($(activeNav).css('padding-left'));
  var activePadRight = parseFloat($(activeNav).css('padding-right'));
  var totalWidth = activewidth + activePadLeft + activePadRight;
  var precedingAnchorWidth = anchorWidthCounter();
  var activeMarker = $('.cm-toggle-list hr');
  $(activeMarker).css('display','block');
  $(activeMarker).css('width', totalWidth);
  $(activeMarker).css('left', precedingAnchorWidth);
}
moveMarker();
function anchorWidthCounter() {
  var anchorWidths = 0;
  var a;
  var aWidth;
  var aPadLeft;
  var aPadRight;
  var aTotalWidth;
  $('.cm-toggle-item').each(function(index, elem) {
    var activeTest = $(elem).hasClass('isSelected');
    if(activeTest) {
      return false;
    }
    a = $(elem);
    aWidth = a.width();
    aPadLeft = parseFloat(a.css('padding-left'));
    aPadRight = parseFloat(a.css('padding-right'));
    aTotalWidth = aWidth + aPadLeft + aPadRight;
    anchorWidths = anchorWidths + aTotalWidth;
  });
  return anchorWidths;
}
// tab click on change slider of border end

// Close footer tab dropdown & Filter drawer on click outside of dropdown
$(document).on("click",function(e) {
  var $target = $(e.target);

  /* For footer tab dropdown */
  if($target.is(".glm-cm-active") == false && $target.is(".cm-toggle-label") == false && $target.is(".cm-toggle-label span") == false){
    $(".btm_tab").hasClass("glm-cm-active") ? $(".btm_tab").removeClass("glm-cm-active") : '';
    $(".cm-size-mask").hasClass("isShow") ? $(".cm-size-mask").removeClass("isShow") : '';
  }

  /* For filter drawer */
  if($target.parents().is(".cm-filter-slide") == false && $target.parents().is(".cm-filter-bar") == false){
    $(".cm-filter-panel").hasClass("isSelected") ? $(".cm-filter-panel").removeClass("isSelected") : '';
  }
});

// Remove opacity class on select & input
$(document).on("click", ".cm-modifier-card-container", function(){ 
  $(this).find(".cm-modifier-card-content.opacity_cls").removeClass("opacity_cls"); 
});

// Show / Hide advance options
$(document).on("click", ".cm-progress-container .cm-modifier-advanced-options", function() {
  $(this).toggleClass("active");
  $(this).toggleClass("opacity_cls");
  $(this).closest(".cm-modifier-card-list").find(".cm-modifier-card-list-advance").toggleClass("cm-modifier-advanced-active");
});

// main custom tabs
var passportList = false;
const tabMask = document.querySelector(".cm-size-mask");
const toggleList = document.querySelector(".cm-toggle-list");
const toggleLabel = document.querySelector(".cm-toggle-label");
const toggleItems = document.querySelectorAll(".cm-toggle-item");  
const progressContainers = document.querySelectorAll(".cm-progress-container");
toggleLabel.addEventListener("click", function() {
  toggleList.classList.toggle("glm-cm-active");
  tabMask.classList.toggle("isShow");
});
toggleItems.forEach(toggleItem => {
  toggleItem.addEventListener("click", function(e) {
    const dataId = this.getAttribute("data-id");  
    const currInd = getDomIndex(toggleItem);

    var allDiv = this.closest(".cm-navigation").querySelector(".cm-navigation-middle").querySelectorAll(".cm-progress-container");
    allDiv.forEach(div => {
      if(div.classList.contains('back_checkout')){
        div.classList.remove('back_checkout')
      }
    });

    if(window.innerWidth <= 767){
      if(document.querySelector(".glm-cm-preview.mobile-show")){
        if(dataId == 'fabric-choice' || dataId == 'jacket-design' || dataId == 'trouser-design' || dataId == 'waistcoat-design' || dataId == 'shirt-design' || dataId == 'coat-design'){
          document.querySelector(".glm-cm-preview.mobile-show").style.display = 'block';
        }else{
          document.querySelector(".glm-cm-preview.mobile-show").style.display = 'none';
        }
      }
    }
    
    toggleItems.forEach(item => {
      if (item === this) {
      
        if(item.getAttribute("data-id") == 'size-meauserments'){
          item.classList.add("isSelected");
          toggleLabel.querySelector("span").innerHTML = item.textContent;
          let price = $(".glm-cm-panel").find(".cm-popup-footer .cm-ship-price-txt .price").text();

          $(".sz-ppt-sb-panel").find(".sz-ppt-footer-popup .price").text(price);

          $('html, body').animate({ scrollTop: 0 }, 600);
          if($(".sz-ppt-sb-panel").attr("data-customer") != ""){
            if($(".sz-ppt-sb-panel").attr("data-staff-member") == "true"){
              $(".sz-ppt-modifier-multidrawer-slidewrap .sz-ppt-progress-container.isSelected").removeClass("isSelected");
              window.openMainDrawer();
              $(`.sz-ppt-modifier-multidrawer-slidewrap [data-id="customer-search"]`).removeClass("isBacked").addClass('isSelected');

              // If user already selected then show passport list direct (avoid list of user everytime)
              if(window.findData == false){
                $(`.sz-ppt-modifier-multidrawer-slidewrap [data-id="customer-search"]`).removeClass("isBacked").addClass('isSelected');
              }else{
                $(".sz-ppt-modifier-multidrawer-slidewrap").find(".isSelected").removeClass("isSelected");
                $(".sz-ppt-modifier-multidrawer-slidewrap").find(".isBacked").removeClass("isBacked");
                $(`.sz-ppt-modifier-multidrawer-slidewrap [data-id="my-passport-detail"]`).addClass('isSelected');
              }
            }else{
              let customerId = $(".sz-ppt-sb-panel").attr("data-customer");
              //console.log('customerId', customerId);
              if(passportList == false){
                $("body").addClass("size-line-loading");
                setTimeout(() => {
                  window.getSizePassportList(customerId, $(this)); 
                }, 1000);
                
                passportList = true;   
              } else {
                $(".sz-ppt-modifier-multidrawer-slidewrap").find(".isSelected").removeClass("isSelected");
                $(".sz-ppt-modifier-multidrawer-slidewrap").find(".isBacked").removeClass("isBacked");
                $(`.sz-ppt-modifier-multidrawer-slidewrap [data-id="my-passport-detail"]`).addClass('isSelected');
                window.openMainDrawer();
              }
            }
          }else{
            $(".sz-ppt-modifier-multidrawer-slidewrap .sz-ppt-progress-container.isSelected").removeClass("isSelected");
            window.openMainDrawer();
            $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="1"]`).addClass('isSelected');
          }
        }else{
          /*if(item.getAttribute("data-id") == 'waistcoat-design') {

          }*/

          item.classList.add("isSelected");
          toggleLabel.querySelector("span").innerHTML = item.textContent;
          
          if(this.closest(".cm-add-cart").querySelector(".next_button")){
            if(this.closest(".cm-add-cart").querySelector(".next_button").classList.contains("add_to_cart_btn")){
              this.closest(".cm-add-cart").querySelector(".next_button").classList.remove("add_to_cart_btn");
            }
            if(currInd+1 < toggleItems.length){
              this.closest(".cm-add-cart").querySelector(".next_button").value = 'Next';
            }else{
              this.closest(".cm-add-cart").querySelector(".next_button").value = 'Add to cart';
              setTimeout(() => {this.closest(".cm-add-cart").querySelector(".next_button").classList.add("add_to_cart_btn");}, 1000);
            }
          }
        }
      } else {
        item.classList.remove("isSelected");
      }
    });  

    if(e.target.innerHTML.toLowerCase() == 'checkout'){
      let allTab = $(this).parents(".cm-navigation").find(".cm-navigation-middle .cm-progress-container").not("[data-progress='fabric-choice'],[data-progress='size-meauserments'],[data-progress='checkout']").find(".cm-modifier-card-list");
      const totalSize = $(".cm-progress-container[data-progress='checkout'] .cm-main-sizes .cm-modifier-card-container").not(".hide").length;
      let oldHTML = $(".cm-progress-container[data-progress='checkout'] .cm-main-checkout").html();
      let newHTML = '';
      let noteArr = [];
      allTab.each(function(){
        let varIdHTML = '';
        if(!$(this).parents(".cm-progress-container").hasClass("cm-waistcoat-disabled")){
          if($("fabric-list.is-selected").length > 0){
            varIdHTML = "<input type='hidden' class='cm-var-id' value="+$(this).parents(".cm-progress-container").attr("data-var")+">";
          } else {
            varIdHTML = "<input type='hidden' class='cm-var-id' value="+$(this).parents(".cm-progress-container").attr("data-cus-var")+">";
          }
          //varIdHTML = "<input type='hidden' class='cm-var-id' value="+$(this).parents(".cm-progress-container").attr("data-var")+">";
        }

        noteArr.push($(this).find(".cm-modifier-note .extra_note").val());
        newHTML+= "<div class='cm-modifier-card-list' data-tab-progress='"+$(this).parent(".cm-progress-container").data("progress")+"' data-tab-block='"+$(this).parent(".cm-progress-container").data("block")+"'>"+$(this).html()+varIdHTML+"</div>";
      });
      
      if(newHTML && oldHTML !== newHTML){
        $(".cm-progress-container[data-progress='checkout'] .cm-main-checkout").html(newHTML);
        $(".cm-progress-container[data-progress='checkout'] .cm-main-checkout .cm-modifier-card-list").each(function(index) {
          $(this).find(".cm-modifier-note .extra_note").val(noteArr[index]);
        })
      }

      if($(".cm-progress-container[data-progress='checkout'] .cm-main-sizes .err-cls").length > 0){
        $(".cm-navigation-middle").animate({
          scrollTop: $(".cm-progress-container[data-progress='checkout'] .cm-main-sizes .err-cls").offset().top
        }, 1000);
      }
    }else{
      $(this).parents(".cm-add-cart").find(".next_button").removeClass("disabled");
      $(this).parents(".cm-navigation").find(".cm-navigation-middle").animate({ scrollTop: 0 });
    }
    
    progressContainers.forEach(progressContainer => {
      const dataProgress = progressContainer.getAttribute("data-progress");
      if (dataProgress === dataId) {
        progressContainer.classList.add("isSelected");
      } else {
        progressContainer.classList.remove("isSelected");
      }
    });
    setTimeout(() => {
      toggleList.classList.remove("glm-cm-active");
      tabMask.classList.remove("isShow");
    }, 300);
    moveMarker();
  });
  
});

// next button
$(document).on("click", ".next_button", function(){
  let currTab = this.closest(".cm-add-cart").querySelector(".cm-toggle-list").querySelector(".isSelected");
  var currIndex = getDomIndex(currTab);
  if(currIndex+1 <= (toggleItems.length)-1){
    $(this).parents(".cm-navigation").find(".cm-navigation-middle").animate({ scrollTop: 0 });
    if($(this).parents(".cm-navigation").find(".is_open").length > 0){
      $(this).parents(".cm-navigation").find(".is_open .started_btn").trigger("click");
      return;
    }
    toggleItems[currIndex+1].dispatchEvent(new CustomEvent("click"));
    return;
  }
});

function getDomIndex (target) {
  return [].slice.call(target.parentNode.children).indexOf(target)
}

// Fabric item info drawer (open/close)
const infoWrap = document.querySelector(".info-drawer");
document.querySelectorAll(".info-drawer").forEach(infoWrap => {
  infoWrap.querySelectorAll(".cm-close").forEach(button => {
    button.addEventListener("click", function(){
      this.closest(".info-drawer").classList.contains("isSelected") ? this.closest(".info-drawer").classList.remove("isSelected") : '';
    });
  });
});

$(document).on("click", "fabric-list .cm-info-btn", function(){
  $(".cm-info-wrap").toggleClass("isSelected");
  $(".cm-info-wrap").find(".cm-info-card-main").html('');
  let proTitle = $(this).parent(".cm-card-info-button").data("title");
  proTitle ? $(".cm-info-wrap").find(".cm-header h2").text(proTitle) : null;
  setTimeout(() => {
    $(".cm-info-wrap").find(".cm-info-card-main").html($(this).parents(".cm-card-info-button").find(".cm-pro-description").html());
  }, 300);
});


// Open custom fabric drawer (Only staff member)
$(document).on("click", ".btn-fabric-cstm", function() {
  if($(".cm-fabric-wrap").length > 0) {
    $(".cm-fabric-wrap").addClass("isSelected");
  }
});

// Add fabric data
$(document).on("keyup", ".cm-fabric-wrap .input", function() {
  const $group = $(this).closest(".sz-ppt-fgroup");
  const $inputs = $group.find(".input");
  const allFilled = $inputs.filter(function() {
    let val = $(this).hasClass("fab-price") ? $(this).val().replace(/[^0-9.]/g, '') : $(this).val();
    $(this).val(val);
    return val !== '';
  }).length === $inputs.length;
  $group.find(".ppt-btn").toggleClass("disabled", !allFilled);
});

// Apply custom fabric data
$(document).on("click", ".apply-cstm-fabric", function() {
  let price = $(this).parents(".sz-ppt-fgroup").find(".fab-price").val();
  let title = $(this).parents(".sz-ppt-fgroup").find(".fab-title").val();
  let mill = $(this).parents(".sz-ppt-fgroup").find(".fab-mill").val();
  let articleNo = $(this).parents(".sz-ppt-fgroup").find(".fab-article-no").val();
  
  // set waistcoat price 0 when add fabric
  let waistcoatDataContent = $(this).closest(".cm-navigation-middle").find(".cm-progress-container[data-progress='waistcoat-design'] .cm-modifier-card-list .cm-modifier-card-container .cm-data-content")
  waistcoatDataContent.find(".add_waistcoat .pro_option").val(0);

  // waistcoat unselect when select custom fabric
  if(waistcoatDataContent.find(".add_waistcoat.is_product.is-selected").length > 0) {
    waistcoatDataContent.find(".add_waistcoat.is_product.is-selected").siblings(".cm-drawer-container").addClass("is-selected");
    waistcoatDataContent.find(".add_waistcoat.is_product.is-selected").removeClass("is-selected");
    waistcoatDataContent.find(".add_waistcoat").parents(".cm-modifier-card-container").find(".cm-modifier-result-name .cm-modifier-result-title").text("NO (STANDARD)");
    waistcoatDataContent.find(".add_waistcoat").parents(".cm-modifier-card-container").siblings(".cm-modifier-card-container").addClass("cm-modifier-disable");
    $(this).closest(".cm-navigation-middle").find(".cm-progress-container[data-progress='waistcoat-design']").addClass("cm-waistcoat-disabled");

    $(".sz-ppt-main").find(".sz-ppt-progress-container[data-id='my-passport-detail'] .sz-ppt-mybox-wrapper[data-type='waistcoat-passport']").addClass("hide");
    $(".sz-ppt-main").find(".sz-ppt-progress-container[data-id='my-passport-detail']").find(".sz-ppt-footer-popup .add-to-cart-passport").removeClass("disabled");
    $(this).parents(".cm-navigation").find(".cm-navigation-middle .cm-progress-container[data-progress='checkout']").find(".is_waistcoat_option").addClass("hide");
    $(".cm-drawer-cstm-fab-option").removeClass("active");
  }

  $("fabric-list.is-selected").removeClass("is-selected");
  $(".cm-progress-container[data-progress='checkout']").find(".fabric_summary .cm-modifier-col-title").text(title);
  $(".cstm-fab-item").removeClass("hide").addClass("active");
  $(".cstm-fab-item").find(".cstm-fab-title").text(title);
  $(".cstm-fab-item").find(".cstm-fab-price").text(Shopify.formatMoney(parseFloat(price)*100), Shopify.money_format);
  $(".cstm-fab-item").find("input[name='mill']").val(mill);
  $(".cstm-fab-item").find("input[name='article-code']").val(articleNo);
  $(".cstm-fab-item").find("input[name='price']").val(price);
  updatePrice();
  $(this).parents(".cm-fabric-in").find(".cm-close").trigger("click");
});

// Add custom fabric waistcoat price (Only staff member)
$(document).on("keyup", ".cstm-fab-wstct-price", function() {
  let inputVal = $(this).val().replace(/[^0-9.]/g, '');
  $(this).val(inputVal);
  let currVal = inputVal > 0 ? parseFloat(inputVal) : 0;
  $(this).parents(".cm-drawer-list").find(".is_product .pro_option").val(currVal*100);
  $(this).parents(".cm-navigation").find(".cm-navigation-middle .isSelected .active-option").closest(".cm-modifier-card-container").find(".pro_option").val(currVal*100);
  setTimeout(() => { updatePrice(); }, 500);
});


// Search fabric
$(document).on("input", ".cm-search-bar__input", function(){
  var obj = $(this);
  updateCardCountData(obj);
});

$(document).on("click", ".cm-search-bar__input", function(){
  var this_obj = $(this);
  $(this).parents(".cm-search-filter-bar").addClass("cm-search-focus");
  $(this).parents(".cm-search-bar").find(".cm-search-count").css("display", "flex");
  updateCardCountData(this_obj);
  if($(".cm-filter-panel").hasClass("isSelected")){
    $(".cm-filter-panel").removeClass("isSelected");
    $(".cm-filter-panel").find(".cm-filter-content").find('input:checkbox').removeAttr('checked');
  }
});

$(document).on('click', '.cm-search-close', function(){
  var obj = $(this);
  $(this).parents(".cm-search-filter-bar").removeClass("cm-search-focus");
  $(this).parents(".cm-search-bar").find(".cm-search-count").css("display", "none");
  $(this).parents(".cm-search-bar").find(".cm-search-bar__input").val('');
  updateCardCountData(obj);
  if($(this).parents(".cm-header").find(".filter-bar-buttons").hasClass("visible-hidden")){
    $(this).parents(".cm-header").find(".filter-bar-buttons").removeClass("visible-hidden");
  }
});

function updateCardCountData(obj){
  let searchValue = obj.val().trim().toLowerCase();
  let cardCount = 0;  
  let anyCardFound = false;
  let drawerSearch = false;
  let cardContainersItem,containerDiv,cardTitle;

  if(obj.parents(".cm-modifier-drawer").length > 0){
    cardContainersItem = obj.parents(".cm-modifier-drawer-wrap").find(".cm-drawer-container");
    //cardContainersItem = obj.parents(".cm-modifier-drawer").find(".cm-drawer-container");
    containerDiv = obj.parents(".cm-modifier-drawer");
    drawerSearch = true;
  }else{
    cardContainersItem = obj.parents(".cm-progress-container").find(".cm-card-container");
    containerDiv = obj.parents(".cm-progress-container");
  }
  //var cardContainersItem = obj.parents(".cm-progress-container, .cm-modifier-drawer").find(".cm-card-container");
  
  cardContainersItem.each(function(e){
    if(drawerSearch == true){
      cardTitle = $(this).find('.cm-drawer-title strong').text().toLowerCase();
    }else{
      cardTitle = $(this).find('.cm-card-title').text().toLowerCase();
      $(this).find(".cm-card-image-container").find(".cm-pro-description").find("tr").each((ind, val) => {
        let $row = $(val);
        let key = $row.find("td:first").text().trim().toLowerCase();
        if (key === 'article code') {
          let value = $row.find("td:last").text().trim().toLowerCase();
          if(value != ''){ 
            cardTitle = cardTitle+" "+value;
          }
        }
      });
    }
    
    if (cardTitle.includes(searchValue)) {
      cardCount++;
      $(this).css("display", "block");
      anyCardFound = true;
    } else {
      $(this).css("display", "none");
    }
  });

  if (anyCardFound) {
    containerDiv.removeClass('cm-empty-container');
  } else {
    containerDiv.addClass('cm-empty-container');
  } 
  obj.parents(".cm-search-bar").find(".count").text(`${cardCount}/${cardContainersItem.length}`);
}

// Search fabric (mobile)
$(document).on("click", ".mob_search_button", function(){
  $(this).parents(".filter-bar-buttons").addClass("visible-hidden");
  $(this).parents(".cm-header").find(".cm-search-filter-bar").addClass("cm-search-focus");
  $(".cm-filter-panel").find(".cm-filter-content").find('input:checkbox').removeAttr('checked');
  $(this).parents(".cm-header").find(".cm-search-bar").find(".cm-search-count").css("display", "flex");
  $(this).parents(".cm-header").find(".cm-search-filter-bar").find(".cm-search-bar__input").trigger("input");
});

// filter drawer
const filterButtons = document.querySelectorAll(".cm-filter-buttons");
const filterClose = document.querySelectorAll(".cm-filter-close");
const filterPanel = document.querySelector(".cm-filter-panel");
filterButtons.forEach(button => {
  button.addEventListener("click", toggleFilterPanel);
});

function toggleFilterPanel() {
  filterPanel.classList.toggle("isSelected");
  if(filterPanel.classList.contains("isSelected")){
    filterPanel.querySelectorAll(".cm-filter-control").forEach(control => {
      control = control.querySelector(".cm-filter-content-list").querySelectorAll(".cm-filter-content-item").length == 0 ? control.style.display = 'none' : control;
    });
  }
}

if(filterClose){
  filterClose.forEach(closeBtn => {
    closeBtn.addEventListener("click", function(){
      document.querySelector(".cm-filter-buttons").dispatchEvent(new Event("click"));
    });
  });
}

$(document).on("click", ".mob_filter_button", function(){
  setTimeout(() => {
    $(".cm-filter-buttons").trigger("click");
  }, 300);
});

// Close fabric info drawer (mobile)
$(document).on("click", ".btn-return", function(){
  $(this).closest(".info-drawer").find(".cm-header .cm-close").trigger("click");
});

$(document).on("click", ".cm-size-popup .cm-size-close", function(){
  $(this).parents(".cm-size-popup").hasClass("isSelected") ? $(this).parents(".cm-size-popup").removeClass("isSelected") : '';
  $(".cm-full-mask").hasClass("isShow") ? $(".cm-full-mask").removeClass("isShow") : '';
});

/* Change fabric */
class changeFabrics extends HTMLElement{
  constructor(){
    super();
    //this.vatTitle = "Custom waistcoat";
    this.totalPrice = document.querySelector(".cm-popup-footer").querySelector(".price");
    this.addEventListener("click", this.onChangeData.bind(this));
  }

  onChangeData(event){
    this.updateActiveClass();
    this.updateMainImage();
    this.updateVariantData();
    this.updatePrice();
    this.updateCheckoutTabData();
  }

  updateActiveClass(){
    const cardContainers = this.closest(".cm-card-main").querySelectorAll(".cm-card-container");
    cardContainers.forEach(c => c.classList.remove("is-selected"));
    this.classList.add("is-selected");
    document.querySelector(".cstm-fab-item.active")?.classList.replace("active", "hide");
  }
  
  updateMainImage(){
    if(this.querySelector(".cm-card-image img") && this.querySelector(".cm-card-image img").getAttribute("data-img")){
      let imageSrc = this.querySelector(".cm-card-image img").getAttribute("data-img");
      document.querySelectorAll(".cm-preview-block").forEach(imgBlock => {
        if(imgBlock.querySelector("img")){
          imgBlock.querySelector("img").setAttribute("src", imageSrc);
        }
      });
    }
  }
  
  updateVariantData(){
    var titleArray = ['jacket', 'trousers', 'waistcoat', 'tuxedo-jacket', 'tuxedo-trousers', 'tuxedo-waistcoat', 'tuxedo-waistcoast', 'raglan-coat', 'overcoat'];
    this.variantList().find((variant) => {
      let title = variant['title'];
      let titleDown = title.toLowerCase().replace(" ", '-');
      let varPrice = Shopify.formatMoney(variant.price, Shopify.money_format);
      
      if(titleArray.includes(titleDown)){
        if((titleDown == 'jacket') && !this.closest(".cm-card-list").classList.contains("tuxedo_product") && this.closest(".cm-navigation-middle").querySelector(".cm-progress-container[data-progress='jacket-design']")){
          this.closest(".cm-navigation-middle").querySelector(".cm-progress-container[data-progress='jacket-design']").dataset.var = variant.id;
        }else if((titleDown == 'tuxedo-jacket') && this.closest(".cm-card-list").classList.contains("tuxedo_product") && this.closest(".cm-navigation-middle").querySelector(".cm-progress-container[data-progress='jacket-design']")){
          this.closest(".cm-navigation-middle").querySelector(".cm-progress-container[data-progress='jacket-design']").dataset.var = variant.id;
        }else if((titleDown == 'trousers' || titleDown == 'trouser') && !this.closest(".cm-card-list").classList.contains("tuxedo_product") && this.closest(".cm-navigation-middle").querySelector(".cm-progress-container[data-progress='trouser-design']")){
          this.closest(".cm-navigation-middle").querySelector(".cm-progress-container[data-progress='trouser-design']").dataset.var = variant.id;
        }else if((titleDown == 'tuxedo-trousers' || titleDown == 'tuxedo-trouser') && this.closest(".cm-card-list").classList.contains("tuxedo_product") && this.closest(".cm-navigation-middle").querySelector(".cm-progress-container[data-progress='trouser-design']")){
          this.closest(".cm-navigation-middle").querySelector(".cm-progress-container[data-progress='trouser-design']").dataset.var = variant.id;
        }else if((titleDown == 'waistcoat') && !this.closest(".cm-card-list").classList.contains("tuxedo_product") && this.closest(".cm-navigation-middle").querySelector(".cm-progress-container[data-progress='waistcoat-design']")){
          this.closest(".cm-navigation-middle").querySelector(".cm-progress-container[data-progress='waistcoat-design']").dataset.var = variant.id;
          if(this.closest(".cm-navigation-middle").querySelector(".cm-progress-container[data-progress='waistcoat-design'] .cm-modifier-card-list").querySelector(".cm-modifier-card-container .cm-data-content .add_waistcoat")){
            let yesOptionHtml = this.closest(".cm-navigation-middle").querySelector(".cm-progress-container[data-progress='waistcoat-design'] .cm-modifier-card-list .cm-modifier-card-container .cm-data-content .add_waistcoat .cm-drawer-title span");
            this.closest(".cm-navigation-middle").querySelector(".cm-progress-container[data-progress='waistcoat-design'] .cm-modifier-card-list .cm-modifier-card-container .cm-data-content .add_waistcoat .pro_option").value = variant.price;
            yesOptionHtml ? yesOptionHtml.innerHTML = "("+varPrice+")" : '';
          }
        }else if((titleDown == 'tuxedo-waistcoat' || titleDown == 'tuxedo-waistcoast') && this.closest(".cm-card-list").classList.contains("tuxedo_product") && this.closest(".cm-navigation-middle").querySelector(".cm-progress-container[data-progress='waistcoat-design']")){
          this.closest(".cm-navigation-middle").querySelector(".cm-progress-container[data-progress='waistcoat-design']").dataset.var = variant.id;
          if(this.closest(".cm-navigation-middle").querySelector(".cm-progress-container[data-progress='waistcoat-design'] .cm-modifier-card-list")
             .querySelector(".cm-modifier-card-container .cm-data-content .add_waistcoat")){
            let yesOptionHtml = this.closest(".cm-navigation-middle").querySelector(".cm-progress-container[data-progress='waistcoat-design'] .cm-modifier-card-list .cm-modifier-card-container .cm-data-content .add_waistcoat .cm-drawer-title span");
            this.closest(".cm-navigation-middle").querySelector(".cm-progress-container[data-progress='waistcoat-design'] .cm-modifier-card-list .cm-modifier-card-container .cm-data-content .add_waistcoat .pro_option").value = variant.price;
            yesOptionHtml ? yesOptionHtml.innerHTML = "("+varPrice+")" : '';
          }
        } else if((titleDown == 'raglan-coat') && !this.closest(".cm-card-list").classList.contains("tuxedo_product") && this.closest(".cm-navigation-middle").querySelector(".cm-progress-container[data-block='raglan-coats']")){
          this.closest(".cm-navigation-middle").querySelector(".cm-progress-container[data-progress='coat-design']").dataset.var = variant.id;
        }else if((titleDown == 'overcoat') && !this.closest(".cm-card-list").classList.contains("tuxedo_product") && this.closest(".cm-navigation-middle").querySelector(".cm-progress-container[data-block='overcoat']")){
          this.closest(".cm-navigation-middle").querySelector(".cm-progress-container[data-progress='coat-design']").dataset.var = variant.id;
        }
      }else{
        if(this.closest(".cm-navigation-middle").querySelector(".cm-progress-container[data-progress='shirt-design']")){
          this.closest(".cm-navigation-middle").querySelector(".cm-progress-container[data-progress='shirt-design']").dataset.var = variant.id;
        }
      }
    });
  }

  updatePrice(){
    var newPrice = 0;
    setTimeout(() => {
      document.querySelector(".glm-cm-panel").querySelector(".cm-navigation .cm-navigation-middle").querySelectorAll(".is_product.is-selected").forEach(selected => {
        if(selected.closest(".cm-progress-container").dataset.progress != 'checkout'){
          newPrice = parseFloat(newPrice + parseFloat(selected.querySelector(".pro_option").value));
        }
      });
      document.querySelector(".cm-main .cm-navigation-bottom .price").innerHTML = Shopify.formatMoney(newPrice, Shopify.money_format); 
    }, 300);
  }

  updateCheckoutTabData(){
    document.querySelector(".cm-progress-container[data-progress='checkout']").querySelector(".fabric_summary .cm-modifier-col-title")
      .innerHTML = this.querySelector(".cm-card-title").innerHTML;
  }
  
  variantList(){
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define("fabric-list", changeFabrics);

// Trigger only specific fabric on page load
window.addEventListener("DOMContentLoaded", () => {
  const urlParams = new URLSearchParams(window.location.search);
  const fab = urlParams.get('fab');
  if (fab) {
    const fabricItem = document.querySelector(`fabric-list[data-handle="${fab}"]`) || document.querySelector(`fabric-list[data-org-handle="${fab}"]`);
    if (fabricItem) {
      fabricItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => {
        fabricItem.click();
        $("body").removeClass("size-line-loading");
      }, 100);
    } else if(document.querySelector(".btn-fabric-cstm")) {
      autoFillCustomFabric();
    } 
  } else {
    $("body").removeClass("size-line-loading");
  }
});

// Auto fill custom fabric details (For the staff member only)
function autoFillCustomFabric() {
  const cookieData = window.getCmCopiedCookie();
  //if (!cookieData) return;
  if(cookieData) {

    let fabricDetails = null;
    let totalPrice    = 0;

    if (window.isCookieData()) {

      Object.entries(cookieData).forEach(([pieceType, pieceData]) => {
        const customFabric  = pieceData['_custom_fabric'];
        const fabricData    = pieceData['_fabric_details'];

        if (!customFabric) return;

        if(document.body.dataset.page == 'custom-made-tuxedo-waistcoat' || document.body.dataset.page == 'custom-made-waistcoat') {
          totalPrice += parseFloat(customFabric.price);
        } else {
          if (pieceType !== 'waistcoat') {
            const price = parseFloat(customFabric.price) || 0;
            totalPrice += price;
          }
        }
        /*if (pieceType !== 'waistcoat') {
          const price = parseFloat(customFabric.price) || 0;
          totalPrice += price;
        } else {
          totalPriceWstct += parseFloat(customFabric.price);
        }*/

        // Use fabric details from first available piece (all pieces share same fabric)
        if (!fabricDetails && fabricData) {
          fabricDetails = fabricData;
        }
      });
    }
    if (!fabricDetails) return;

    // Normalize fabric details keys
    const normalize = (obj) => {
      const result = {};
      Object.entries(obj).forEach(([key, value]) => {
          result[key.toLowerCase().replace(/\s+/g, '_')] = value;
      });
      return result;
    };
    const normalizedFabric = normalize(fabricDetails);
    const fields = {
      '.fab-title'     : normalizedFabric.title         || '',
      '.fab-price'     : totalPrice.toString()          || '',
      '.fab-mill'      : normalizedFabric.mill          || '',
      '.fab-article-no': normalizedFabric.article_code  || '',
    };

    Object.entries(fields).forEach(([selector, value]) => {
      const input = document.querySelector(".cm-fabric-card-main").querySelector(selector);
      if (!input) return;
      input.value = value;
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });

    // Remove disabled and trigger Apply button
    const applyBtn = document.querySelector(".cm-fabric-card-main").querySelector('.apply-cstm-fabric');
    if (applyBtn) {
      applyBtn.classList.remove('disabled');
      applyBtn.click();
    }
    
    setTimeout(() => { updatePrice(); }, 500);
    
    // Scroll to custom fabric button
    const customFabricBtn = document.querySelector('.cstm-fab-item');
    if (customFabricBtn) {
      setTimeout(() => {
        const cardList = document.querySelector('.cm-navigation-middle');
        if (cardList) {
          cardList.scrollTo({
            top     : cardList.scrollHeight,
            behavior: 'smooth'
          });
        }
        $("body").removeClass("size-line-loading");
      }, 500); // slight delay to let apply button finish
    }
  } else {
    $("body").removeClass("size-line-loading");
  }
}


// Fabric filter
const fabList = document.querySelectorAll("fabric-list");
if(window.innerWidth >= 990){
  const filterCheckbox = document.querySelectorAll(".cm-filter-checkbox");
  filterCheckbox.forEach(filter => {
    filter.addEventListener("click", function(){
      let thisObj = $(this);
      fabricFilter(thisObj);
    })
  });
}

if(window.innerWidth < 992){
  if(document.querySelector(".filter_apply")){
    const filterApply = document.querySelector(".filter_apply");
    if(filterApply){
      filterApply.addEventListener("click", function(){
        let thisObj = $(this);
        fabricFilter(thisObj);
        this.closest(".cm-add-btns").querySelector(".cm-filter-close").dispatchEvent(new Event("click"));
      });
    }
  }
}

function fabricFilter(event){
  const arr1 = [...document.querySelectorAll('.cm-filter-checkbox:checked')].map(e => e.value);
  if(arr1.length > 0){
    let counter = 0;
    fabList.forEach(fab => {
      if(fab.querySelector(".cm-card-content-wrapper").dataset.tag){
        const arr2 = JSON.parse(fab.querySelector(".cm-card-content-wrapper").dataset.tag);
        const hasAllElems = arr1.every(elem => arr2.includes(elem));
        if(hasAllElems == true){
          fab.style.display = 'block';
          counter+= 1;
        }else{
          fab.style.display = 'none';
        }
      }
    });
    if(counter == 0){
      $(event).parents(".glm-cm-panel").find(".cm-side-viewer .cm-navigation-middle .cm-progress-container.isSelected").addClass("cm-empty-container");
    }else{
      $(event).parents(".glm-cm-panel").find(".cm-side-viewer .cm-navigation-middle .cm-progress-container.isSelected").removeClass("cm-empty-container");
    }
  }else{
    fabList.forEach(fab => {
      fab.style.display = 'block';
    });
  }
}

$(document).ready(function(){

  // Open option details drawer
  $(document).on("click", ".cm-modifier-card-content", function(){
    $(this).parents(".cm-modifier-card-list").find(".active-option").removeClass("active-option");
    $(this).addClass("active-option");
    let drawerType = $(this).data("drawer");

    if($(this).parents(".cm-main-checkout").length > 0){
      let progressTab = $(this).parents(".cm-modifier-card-list").attr("data-tab-progress");
      const currIndex = parseInt($(this).parents(".cm-modifier-card-list").find(this).parents(".cm-modifier-card-container").attr("data-index"));
      $(".btm_tab").find(".cm-toggle-item[data-id='"+progressTab+"']").trigger("click");
      $(this).parents(".cm-navigation-middle").find(".cm-progress-container").removeClass("back_checkout");
      $(this).parents(".cm-navigation-middle").find(".cm-progress-container[data-progress='"+progressTab+"']").addClass("back_checkout");
      setTimeout(() => {
        $(".cm-progress-container[data-progress='"+progressTab+"']").find(".cm-modifier-card-list .cm-modifier-card-content").eq(currIndex - 1).trigger("click");
      },100);
    }
    if($(this).parents(".cm-main-sizes").length > 0){
      const progressTab = $(this).parents(".cm-modifier-card-list").attr("data-tab-progress");
      $(".btm_tab").find(".cm-toggle-item[data-id='"+progressTab+"']").trigger("click");
    }

    if(drawerType){
      let currDrawer = $(this).parents(".cm-navigation").find(".cm-modifier-drawer[drawer-type='"+drawerType+"']");
      currDrawer.find(".cm-modifier-drawer-wrap").removeClass('cm-fade-in');
      setTimeout(() => {
        if($(this).parents(".cm-modifier-card-container").find(".cm-data-content")){
          let drawerNewData = $(this).parents(".cm-modifier-card-container").find(".cm-data-content").html();

          setTimeout(() => {
            currDrawer.find(".cm-modifier-drawer-wrap").addClass('cm-fade-in');
          }, 200);

          if(drawerType == 'four'){
            currDrawer.find(".cm-modifier-multidrawer-slidewrap").html(drawerNewData);

            // set value of other option (staff member)
            let otherOptVal = $(this).find(".cm-modifier-result-name .cm-modifier-result-title").text().trim().split(", ");
            
            currDrawer.find(".cm-modifier-drawer-wrap").each((index, subDrawer) => {
              if($(subDrawer).find(".cm-drawer-other-option").hasClass("active")){
                $(subDrawer).find(".cm-drawer-other-option").find(".other-option").val(otherOptVal[index]);
              }
            });

          }else{
            currDrawer.find(".cm-modifier-drawer-wrap").html(drawerNewData);
            
            // set value of other option (staff member)
            if(currDrawer.find(".cm-drawer-other-option").hasClass("active")){
              let otherOptVal = $(this).find(".cm-modifier-result-name .cm-modifier-result-title").text().trim();
              currDrawer.find(".cm-modifier-drawer-wrap .other-option").val(otherOptVal);
            }
            
            if(currDrawer.find(".cm-drawer-cstm-fab-option").hasClass("active")){
              let wstctFabPrice = $(this).parents(".cm-modifier-card-container").find(".cm-data-content .is_product.is-selected .pro_option").val();
              currDrawer.find(".cm-drawer-cstm-fab-option.active .cstm-fab-wstct-price").val(parseFloat(wstctFabPrice)/100);
              if(!$(".cstm-fab-item").hasClass("active")){
                currDrawer.find(".cm-drawer-cstm-fab-option").removeClass("active")
              }
            } 
          }
        }
        currDrawer.addClass("isSelected");
        /*if(drawerType == 'two') {
          currDrawer.addClass("is_transition");
        } else {
          $(".cm-modifier-drawer[drawer-type='two']").hasClass("is_transition") ? $(".cm-modifier-drawer[drawer-type='two']").removeClass("is_transition") : '';
        }*/

        if(drawerType == 'four'){
          document.querySelector(".cm-modifier-drawer[drawer-type='"+drawerType+"']").querySelector(".cm-modifier-multidrawer-slidewrap").style.setProperty('--slider-current', 0);
          if($(".cm-modifier-drawer[drawer-type='"+drawerType+"']").find(".close_btn").hasClass("back_btn")){
            $(".cm-modifier-drawer[drawer-type='"+drawerType+"']").find(".close_btn").removeClass("back_btn");
          }
          if(!$(".cm-modifier-drawer[drawer-type='"+drawerType+"'] .cm-modifier-drawer-wrap[drawer-step='1']").find(".is-selected").hasClass("option-none")){
            $(".cm-modifier-drawer[drawer-type='"+drawerType+"']").find(".cm-modifier-drawer-bottom .apply_btn").val('Next');
            $(".cm-modifier-drawer[drawer-type='"+drawerType+"']").find(".cm-modifier-drawer-bottom .apply_btn").addClass("drawer-four-next-btn");
          }else{
            $(".cm-modifier-drawer[drawer-type='"+drawerType+"']").find(".cm-modifier-drawer-bottom .apply_btn").val('Next');
          }
        }
      }, 300);
    }
  });

  /* Drawer close */
  $(document).on("click", ".cm-close-drawer", function(){
    // When custom fabric waistcoat price not added or 0 added (staff member)
    if(checkCustomFabWaistcoatPrice($(this)) == false) {
      return;
    }

    if($(this).parents(".cm-navigation").find(".cm-progress-container.back_checkout").length > 0){
      $(".btm_tab").find(".cm-toggle-item[data-id='checkout']").trigger("click");
      $(this).parents(".cm-modifier-drawer").hasClass("isSelected") ? $(this).parents(".cm-modifier-drawer").removeClass("isSelected") : $(this);
    }else{
      $(this).parents(".cm-modifier-drawer").hasClass("isSelected") ? $(this).parents(".cm-modifier-drawer").removeClass("isSelected") : $(this);
    }
  });

  $(document).on("click", ".close_btn", function(){
    if(!$(this).hasClass("back_btn")){
      // When custom fabric waistcoat price not added or 0 added (staff member)
      if(checkCustomFabWaistcoatPrice($(this)) == false) {
        return;
      }

      $(this).parents(".cm-modifier-drawer").find(".cm-close-drawer") ? $(this).parents(".cm-modifier-drawer").find(".cm-close-drawer.desk-close-drawer").trigger("click") : $(this);
    }
  });

  /* CM to INCH & INCH to CM in drawer */
  $(document).on("click", ".cm-modifier-drawer .cm-modifier-drawer-wrap .cm-drawer-cm-in label", function(){
    let checkBoxes = $(this).parents(".cm-drawer-cm-in").find("input[type='checkbox'].cm-measure-unit");
    !checkBoxes.is(':checked') ? checkBoxes.prop('checked', true).attr('checked', 'checked') : checkBoxes.prop('checked', false).removeAttr('checked');
 
    setTimeout(() => {
      let isChecked = $(this).parents(".cm-drawer-cm-in").find("input[type='checkbox']").is(":checked");
      let currVal = parseFloat($(this).parents(".cm-drawer-custom-cont").find(".cm_custom_size").val());
      if(currVal){
        let newVal = isChecked ? Math.round(.393701 * currVal * 5) / 5 : Math.round(2.54 * currVal * 2) / 2;
        $(this).parents(".cm-drawer-custom-cont").find(".cm_custom_size").attr('value', newVal).val(newVal);
      }
    }, 500);
  });




  // Other option (for Staff Member only)
  $(document).on("click", ".cm-drawer-other-option-btn", function() {
    $(this).parents(".cm-drawer-other-option").addClass("active");
    $(this).parents(".cm-drawer-other-option").find(".other-option")
    .focus()
    .val('')
    .get(0)
    .scrollIntoView({
      behavior: 'smooth',
      block: 'end'
    });
  });

  $(document).on("keyup", ".other-option", function() {
    let selectedTitle = $(this).val();
    if(selectedTitle.trim() != '') {
      setTimeout(() => {
        $(this).parents(".cm-navigation").find(".cm-navigation-middle .isSelected .active-option .cm-modifier-result-title").text(selectedTitle);
      }, 100);
    } else {
      $(this).parents(".cm-modifier-drawer-wrap").find(".cm-drawer-container").eq(0).trigger("click");
    }
  });


  
  /* DRAWER 1, 3, 5 */
  // Select option from drawer
  $(document).on("click", ".cm-modifier-drawer[drawer-type='one'] .cm-drawer-list .cm-drawer-container", function(){
    if($(this).hasClass("is-selected")){ return false; }
    $(this).parents(".cm-modifier-drawer[drawer-type='one']").find(".cm-modifier-drawer-bottom").find(".drawer1_apply").addClass("inactive_button");
    $(this).parents(".cm-modifier-drawer-wrap").find(".cm-drawer-container.is-selected").removeClass("is-selected");
    $(this).addClass("is-selected");

    // Hide other option when click on options (excepted other option (staff member))
    if($(this).parent(".cm-drawer-other-option").length == 0){
      $(this).parents(".cm-modifier-drawer-wrap").find(".cm-drawer-other-option.active").removeClass("active");
    }

    document.body.classList.add("line-loading-3d-preview");
    setTimeout(() => {
      $(this).parents(".cm-modifier-drawer[drawer-type='one']").find(".cm-modifier-drawer-bottom").find(".drawer1_apply").trigger("click");
    }, 100);
  });

  // Hide Single & Dual chest pocket on collar style Horse shoe (while first option is Horse shoe)
  if($("body").hasClass("is_tuxedo_page")){
    if($(".cm-progress-container[data-progress='waistcoat-design']").find(".cm-modifier-card-list-base .clicked_option .is-selected.horse_shoe_option").length > 0){
      $(".cm-progress-container[data-progress='waistcoat-design']").find(".cm-modifier-card-list-base .chest_pocket .chestpocket_hide_option").css("display", "none");
    }
  }

  // Apply selected button
  $(document).on("click", ".cm-modifier-drawer[drawer-type='one'] .drawer1_apply", function(event){
    let thisObj = $(this).parents(".cm-navigation");
    //return;
    
    let selectedTitle = $(this).parents(".cm-modifier-drawer.isSelected").find(".is-selected .cm-drawer-content strong").text() || $(this).parents(".cm-modifier-drawer.isSelected").find(".other-option").val();
    let customMeasurement = $(this).parents(".cm-modifier-drawer.isSelected").find(".cm-drawer-custom-cont .cm_custom_size").val();
    let measureUnit = $(this).parents(".cm-modifier-drawer.isSelected").find(".cm-drawer-custom-cont input[type='checkbox']").prop("checked") ? " inch" : " cm";

    if(selectedTitle){
      if(customMeasurement){
        thisObj.find(".cm-navigation-middle .isSelected .active-option .cm-modifier-result-title").text(selectedTitle+" "+"("+customMeasurement + measureUnit+")");
      }else{
        thisObj.find(".cm-navigation-middle .isSelected .active-option .cm-modifier-result-title").text(selectedTitle);
      }
    }else if(customMeasurement){
      thisObj.find(".cm-navigation-middle .isSelected .active-option .cm-modifier-result-title").text(customMeasurement + measureUnit);
    }

    let newCustomTxt = $(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-wrap").html();
    if(newCustomTxt){
      thisObj.find(".isSelected .active-option").parents(".cm-modifier-card-container").find(".cm-data-content").html(newCustomTxt);
    }

    var selectedTitleDown = selectedTitle.toLowerCase();
    
    /* Jacket tab option hide show */
    if(thisObj.find(".cm-navigation-middle .isSelected").data("progress") == 'jacket-design' && 
       thisObj.find(".cm-navigation-middle .isSelected .active-option").parents(".clicked_option").length > 0){

      let buttonholeBody = thisObj.find(".cm-navigation-middle .isSelected .buttonhole_body .cm-data-content");
      let liningOpt = thisObj.find(".cm-navigation-middle .isSelected .lining_option .cm-data-content");

      if(!$("body").hasClass("is_tuxedo_page")){
        let butonningOption = thisObj.find(".cm-navigation-middle .isSelected .buttoning_option .cm-data-content");
        let lapelOption = thisObj.find(".cm-navigation-middle .isSelected .lapel_style .cm-data-content");
        let lapelWidthOption = thisObj.find(".cm-navigation-middle .isSelected .lapel_width .cm-data-content");
        let ticketPocket = thisObj.find(".cm-navigation-middle .isSelected .ticket_pocket .cm-data-content");
        let shoulder = thisObj.find(".cm-navigation-middle .isSelected .jacket_shoulder .cm-data-content");
        let jktChestPocket = thisObj.find(".cm-navigation-middle .isSelected .chest_pocket .cm-data-content");
        let sidePockets = thisObj.find(".cm-navigation-middle .isSelected .side_pockets .cm-data-content");
        let construction = thisObj.find(".cm-navigation-middle .isSelected .construction .cm-data-content");
        let vent = thisObj.find(".cm-navigation-middle .isSelected .jacket_vent .cm-data-content");
        let sleeveButton = thisObj.find(".cm-navigation-middle .isSelected .sleeve_button_cls .cm-data-content");
        let cuffedSleeve = thisObj.find(".cm-navigation-middle .isSelected .cuffed_sleeve .cm-data-content");
        let buttonholeLapelPos = thisObj.find(".cm-navigation-middle .isSelected .buttonhole_lapel_pos .cm-data-content");
        let buttonholeLapel = thisObj.find(".cm-navigation-middle .isSelected .buttonhole_lapel .cm-data-content");
        let amf = thisObj.find(".cm-navigation-middle .isSelected .jacket_amf .cm-data-content");
        let darts = thisObj.find(".cm-navigation-middle .isSelected .jacket_darts .cm-data-content");
        let collarFelt = thisObj.find(".cm-navigation-middle .isSelected .collar_felt .cm-data-content");

        let buttoningVal = butonningOption.find(".is-selected .cm-drawer-title strong").text().trim().toLowerCase();
        if(selectedTitleDown.includes("4 button") || selectedTitleDown.includes("4 button low") || selectedTitleDown.includes("6 button") || selectedTitleDown.includes("6 button low") || buttoningVal.includes("4 button") || buttoningVal.includes("4 button low") || buttoningVal.includes("6 button") || buttoningVal.includes("6 button low")){
          hideShowOption (thisObj, lapelOption, '.lapel_style_hidden_option', 'lapel_style');
  
          // Notch peak option
          if((selectedTitleDown.includes("4 button low") || buttoningVal.includes("4 button low"))) {
            lapelOption.find(".notch_peak_option").show();
          } else {
            if(lapelOption.find(".notch_peak_option").hasClass("is-selected")){
              lapelOption.find(".notch_peak_option").removeClass("is-selected");
              lapelOption.find(".cm-drawer-container").not(".notch_peak_option, .lapel_style_hidden_option").eq(0).addClass("is-selected");
              setTimeout(() => {
                let newTxt = lapelOption.find(".is-selected .cm-drawer-title strong").text();
                thisObj.find(".cm-navigation-middle .isSelected .lapel_style .cm-modifier-result-name .cm-modifier-result-title").text(newTxt);
              },100);
            }
            lapelOption.find(".notch_peak_option").hide();
          }

          // Pleat patch option
          if(selectedTitleDown.includes("4 button low") || selectedTitleDown.includes("6 button") || selectedTitleDown.includes("6 button low") || buttoningVal.includes("4 button low") || buttoningVal.includes("6 button") || buttoningVal.includes("6 button low")){
            if(jktChestPocket.find(".chest_pkt_plt_patch_option").hasClass("is-selected")){
              jktChestPocket.find(".chest_pkt_plt_patch_option").removeClass("is-selected");
              jktChestPocket.find(".cm-drawer-container").not(".chest_pkt_plt_patch_option").eq(0).addClass("is-selected");
              setTimeout(() => {
                let newTxt = jktChestPocket.find(".is-selected .cm-drawer-title strong").text();
                thisObj.find(".cm-navigation-middle .isSelected .chest_pocket .cm-modifier-result-name .cm-modifier-result-title").text(newTxt);
              },100);
            }
            jktChestPocket.find(".chest_pkt_plt_patch_option").hide();
          } else {
            jktChestPocket.find(".chest_pkt_plt_patch_option").show();
          }
        } else {
          if(selectedTitleDown.includes("single breasted") && !$("body").hasClass("is_tuxedo_page")){
            lapelOption.find(".lapel_style_hidden_option").show();
            hideShowOption (thisObj, lapelOption, '.notch_peak_option', 'lapel_style');
            jktChestPocket.find(".chest_pkt_plt_patch_option").show();
          }
        }

        let lapelOptVal = lapelOption.find(".is-selected .cm-drawer-title strong").text().trim().toLowerCase();
        // Hide Lapel width options based on Lapel style
        if(lapelOptVal.includes("concave") || lapelOptVal == "peak"){
          hideShowOption (thisObj, lapelWidthOption, '.narrow_option', 'lapel_width');
        }else{
          lapelWidthOption.find(".narrow_option").show();
        }
        
        // Hide buttoning (6 button low) options based on Lapel style & Lapel width
        /*if(lapelOptVal == "peak" && lapelWidthOption.find(".is-selected .cm-drawer-title strong").text().trim().toLowerCase().includes("wide")){
          butonningOption.find(".6_btn_low_option").show();
        }else{
          hideShowOption (thisObj, butonningOption, '.6_btn_low_option', 'buttoning_option');
        }*/

        // Medium lapel width option
        if(buttoningVal.includes("4 button low") || buttoningVal.includes("6 button low") || lapelOptVal == 'notch peak') {
          if(lapelWidthOption.find(".medium_option").hasClass("is-selected")){
            lapelWidthOption.find(".medium_option").removeClass("is-selected");
            lapelWidthOption.find(".cm-drawer-container").not(".medium_option").eq(0).addClass("is-selected");
            setTimeout(() => {
              let newTxt = lapelWidthOption.find(".is-selected .cm-drawer-title strong").text();
              thisObj.find(".cm-navigation-middle .isSelected .lapel_width .cm-modifier-result-name .cm-modifier-result-title").text(newTxt);
            },100);
          }
          lapelWidthOption.find(".medium_option").hide();
        } else {
          lapelWidthOption.find(".medium_option").show();
        }

        // Hide buttoning (4 button low) options based on Lapel style
        /*if((lapelOptVal == "peak" || lapelOptVal == "notch peak") && lapelWidthOption.find(".is-selected .cm-drawer-title strong").text().trim().toLowerCase().includes("wide")){
          butonningOption.find(".4_btn_low_option").show();
        }else{
          //hideShowOption (thisObj, butonningOption, '.4_btn_low_option', 'buttoning_option');
          if(butonningOption.find(".4_btn_low_option").hasClass("is-selected")){
            butonningOption.find(".4_btn_low_option").removeClass("is-selected");
            butonningOption.find(".cm-drawer-container").not(".4_btn_low_option").eq(0).addClass("is-selected");
            setTimeout(() => {
              let newTxt = butonningOption.find(".is-selected .cm-drawer-title strong").text();
              thisObj.find(".cm-navigation-middle .isSelected .buttoning_option .cm-modifier-result-name .cm-modifier-result-title").text(newTxt);
            },100);
          }
          butonningOption.find(".4_btn_low_option").hide();
        }*/

        // Hide/Show multiple options based on 4 button low
        if(selectedTitleDown.includes("4 button low") || butonningOption.find(".is-selected .cm-drawer-title strong").text().trim().toLowerCase().includes("4 button low")){

          if(jktChestPocket.find(".chest_pkt_hidden_option").hasClass("is-selected")){
            jktChestPocket.find(".chest_pkt_hidden_option").removeClass("is-selected");
            jktChestPocket.find(".cm-drawer-container").not(".chest_pkt_hidden_option").eq(0).addClass("is-selected");
            setTimeout(() => {
              let newTxt = jktChestPocket.find(".is-selected .cm-drawer-title strong").text();
              thisObj.find(".cm-navigation-middle .isSelected .chest_pocket .cm-modifier-result-name .cm-modifier-result-title").text(newTxt);
            },100);
          }
          jktChestPocket.find(".chest_pkt_hidden_option").hide();
          
          hideShowOption (thisObj, shoulder, '.shoulder_hidden_option', 'jacket_shoulder');
          hideShowOption (thisObj, sidePockets, '.side_pkt_hidden_option', 'side_pockets');
          hideShowOption (thisObj, construction, '.const_hidden_option', 'construction');
          hideShowOption (thisObj, vent, '.vent_hidden_option', 'jacket_vent');
          hideShowOption (thisObj, sleeveButton, '.hidden_options', 'sleeve_button_cls');
          hideShowOption (thisObj, cuffedSleeve, '.cuffed_yes_option', 'cuffed_sleeve');
          hideShowOption (thisObj, buttonholeLapelPos, '.hidden_option', 'buttonhole_lapel_pos');
          //hideShowOption (thisObj, buttonholeLapel, '.traditional_option', 'buttonhole_lapel');
          hideShowOption (thisObj, amf, '.6mm_option', 'jacket_amf');
          hideShowOption (thisObj, darts, '.dart_yes_option', 'jacket_darts');
          hideShowOption (thisObj, collarFelt, '.tone_on_tone_option', 'collar_felt');
        } else {
          shoulder.find(".shoulder_hidden_option").show();
          jktChestPocket.find(".chest_pkt_hidden_option").show();
          sidePockets.find(".side_pkt_hidden_option").show();
          construction.find(".const_hidden_option").show();
          vent.find(".vent_hidden_option").show();
          sleeveButton.find(".hidden_options").show();
          cuffedSleeve.find(".cuffed_yes_option").show();
          buttonholeLapelPos.find(".hidden_option").show();
          //buttonholeLapel.find(".traditional_option").show();
          amf.find(".6mm_option").show();
          darts.find(".dart_yes_option").show();
          collarFelt.find(".tone_on_tone_option").show();
        }
        
        // Ticket pocket (No option based on side pocket and buttoning options)
        let sidePktVal = sidePockets.find(".is-selected .cm-drawer-title strong").text().trim().toLowerCase();
        if(sidePktVal == 'pleat patch' || sidePktVal == 'patch'){
          hideShowOption (thisObj, ticketPocket, '.tp_yes_option', 'ticket_pocket');
        }else{
          ticketPocket.find(".tp_yes_option").show();
        }
      }

      //For tuxedo
      if($("body").hasClass("is_tuxedo_page")){
        let buttoningTuxedo = thisObj.find(".cm-navigation-middle .isSelected .buttoning_option .cm-data-content");
        let buttoningVal = buttoningTuxedo.find(".is-selected .cm-drawer-title strong").text().trim().toLowerCase();
        let lapelStyleTuxedo = thisObj.find(".cm-navigation-middle .isSelected .lapel_style .cm-data-content");
        let lapelWidthTuxedo = thisObj.find(".cm-navigation-middle .isSelected .lapel_width .cm-data-content");
        
        // Lapel style (peak option)
        if(buttoningVal.includes("4 button low")){
          hideShowOption (thisObj, lapelStyleTuxedo, '.tuxedo_peak_option', 'lapel_style');
        }else {
          lapelStyleTuxedo.find(".tuxedo_peak_option").show();
        }
        
        // Lapel style (shawl option)
        if(buttoningVal.includes("6 button") || buttoningVal.includes("6 button low")){
          hideShowOption (thisObj, lapelStyleTuxedo, '.shawl_option', 'lapel_style');
          hideShowOption (thisObj, lapelWidthTuxedo, '.medium_option', 'lapel_width');
        }else {
          lapelStyleTuxedo.find(".shawl_option").show();
          lapelWidthTuxedo.find(".medium_option").show();
        }


        // Buttoning (4 button low option)
        /*let lapelStyleVal = lapelStyleTuxedo.find(".is-selected .cm-drawer-title strong").text().trim().toLowerCase();
        if(lapelStyleVal == "peak" || selectedTitleDown == "peak") {
          hideShowOption (thisObj, buttoningTuxedo, '.4_btn_low_option', 'buttoning_option');
        } else {
          buttoningTuxedo.find(".4_btn_low_option").show();
        }*/

        // Buttoning (6 button low option)
        /*let lapelWidthTuxVal = lapelWidthTuxedo.find(".is-selected .cm-drawer-title strong").text().trim().toLowerCase();
        if(lapelStyleVal == "peak" && lapelWidthTuxVal.includes("wide")) {
          buttoningTuxedo.find(".6_btn_low_tuxedo_option").show();
        } else {
          if(buttoningTuxedo.find(".6_btn_low_tuxedo_option").hasClass("is-selected")){
            buttoningTuxedo.find(".6_btn_low_tuxedo_option").removeClass("is-selected");
            buttoningTuxedo.find(".cm-drawer-container").not(".6_btn_low_tuxedo_option").eq(0).addClass("is-selected");
            setTimeout(() => {
              let newTxt = buttoningTuxedo.find(".is-selected .cm-drawer-title strong").text();
              thisObj.find(".cm-navigation-middle .isSelected .buttoning_option .cm-modifier-result-name .cm-modifier-result-title").text(newTxt);
            },100);
          }
          buttoningTuxedo.find(".6_btn_low_tuxedo_option").hide();
        }*/

      }

      let btnHoleBodyVal = buttonholeBody.find(".is-selected .cm-drawer-title strong").text().trim().toLowerCase();
      if(btnHoleBodyVal == 'traditional') {
        hideShowOption (thisObj, thisObj.find(".cm-navigation-middle .isSelected .buttonhole_lapel .cm-data-content"), '.handmade_option', 'buttonhole_lapel');
      } else {
        thisObj.find(".cm-navigation-middle .isSelected .buttonhole_lapel .cm-data-content").find(".handmade_option").show();
      }

      /*selectedTitleDown == 'unlined' ? thisObj.find(".cm-navigation-middle .isSelected .lining_color").hide() : 
      thisObj.find(".cm-navigation-middle .isSelected .lining_color").show();*/

      liningOptVal = liningOpt.find(".is-selected .cm-drawer-title strong").text().trim().toLowerCase();
      if(liningOptVal == 'unlined') {
        thisObj.find(".cm-navigation-middle .isSelected .lining_color").hide();
      } else {
        thisObj.find(".cm-navigation-middle .isSelected .lining_color").show();
      }
    }
    /* End Jacket tab option hide show */

    /* Trouser tab option hide show */
    if(thisObj.find(".cm-navigation-middle .isSelected").data("progress") == 'trouser-design' && 
      thisObj.find(".cm-navigation-middle .isSelected .active-option").parents(".clicked_option").length > 0){

      let WaistbandHeight = thisObj.find(".cm-navigation-middle .isSelected .waistband_height_cls .cm-data-content");
      let WaistbandFastening = thisObj.find(".cm-navigation-middle .isSelected .fastening_cls .cm-data-content");
      let liningOptTr = thisObj.find(".cm-navigation-middle .isSelected .lining_option .cm-data-content");

      // For drawstring, gurkha, original gurkha, butterfly
      if(selectedTitleDown.includes('drawstring') || selectedTitleDown.includes('gurkha') || selectedTitleDown.includes('original gurkha') 
        || selectedTitleDown.includes('butterfly')){

        // For waistband height
        if(WaistbandHeight.find(".4cm_option").length > 0 || WaistbandHeight.find(".5cm_option").length > 0){
          if(selectedTitleDown.includes('drawstring')){
            if(!WaistbandHeight.find(".4cm_option").hasClass("is-selected")){
              WaistbandHeight.find(".cm-drawer-container").not(".4cm_option").removeClass("is-selected");
              WaistbandHeight.find(".4cm_option").addClass("is-selected");
              setTimeout(() => {
                let fourCmTxt = WaistbandHeight.find(".is-selected .cm-drawer-title strong").text();
                thisObj.find(".cm-navigation-middle .isSelected .waistband_height_cls .cm-modifier-result-name .cm-modifier-result-title").text(fourCmTxt);
              },100);
            }
            WaistbandHeight.find(".4cm_option").show();
            WaistbandHeight.find(".cm-drawer-container").not(".4cm_option").hide();
          }else if(selectedTitleDown.includes('gurkha') || selectedTitleDown.includes('original gurkha') || selectedTitleDown.includes('butterfly')){
            if(!WaistbandHeight.find(".5cm_option").hasClass("is-selected")){
              WaistbandHeight.find(".cm-drawer-container").not(".5cm_option").removeClass("is-selected");
              WaistbandHeight.find(".5cm_option").addClass("is-selected");
              setTimeout(() => {
                let fourCmTxt = WaistbandHeight.find(".is-selected .cm-drawer-title strong").text();
                thisObj.find(".cm-navigation-middle .isSelected .waistband_height_cls .cm-modifier-result-name .cm-modifier-result-title").text(fourCmTxt);
              },100);
            }
            WaistbandHeight.find(".5cm_option").show();
            WaistbandHeight.find(".cm-drawer-container").not(".5cm_option").hide();
          }
        }

        // For waistband fastening
        if(WaistbandFastening.find(".no_option").length > 0){
          if(!WaistbandFastening.find(".no_option").hasClass("is-selected")){
            WaistbandFastening.find(".cm-drawer-container").not(".no_option").removeClass("is-selected");
            WaistbandFastening.find(".no_option").addClass("is-selected");
            setTimeout(() => {
              let fourCmTxt = WaistbandFastening.find(".is-selected .cm-drawer-title strong").text();
              thisObj.find(".cm-navigation-middle .isSelected .fastening_cls .cm-modifier-result-name .cm-modifier-result-title").text(fourCmTxt);
            },100);
          }
          WaistbandFastening.find(".no_option").show();
          WaistbandFastening.find(".cm-drawer-container").not(".no_option").hide();
        }
        
      }else{
        WaistbandHeight.find(".cm-drawer-container").show();

        if(WaistbandFastening.find(".no_option").hasClass("is-selected")){
          WaistbandFastening.find(".no_option").removeClass("is-selected");
          WaistbandFastening.find(".cm-drawer-container").not(".no_option").eq(0).addClass("is-selected");
          setTimeout(() => {
            let newTxt = WaistbandFastening.find(".is-selected .cm-drawer-title strong").text();
            thisObj.find(".cm-navigation-middle .isSelected .fastening_cls .cm-modifier-result-name .cm-modifier-result-title").text(newTxt);
          },100);
        }
        WaistbandFastening.find(".no_option").hide();
        WaistbandFastening.find(".cm-drawer-container").not(".no_option").show();
      }

      liningOptValTr = liningOptTr.find(".is-selected .cm-drawer-title strong").text().trim().toLowerCase();
      if(liningOptValTr == 'unlined') {
        thisObj.find(".cm-navigation-middle .isSelected .lining_color").hide();
      } else {
        thisObj.find(".cm-navigation-middle .isSelected .lining_color").show();
      }
    }
    /* End Trouser tab option hide show */

    /* Waistcoat tab option hide show */
    if(thisObj.find(".cm-navigation-middle .isSelected").data("progress") == 'waistcoat-design' && 
      thisObj.find(".cm-navigation-middle .isSelected .active-option").parents(".clicked_option").length > 0){

      let chestPocket = thisObj.find(".cm-navigation-middle .isSelected .chest_pocket .cm-data-content");

      if(selectedTitleDown.includes('horse shoe')){
        if (chestPocket.find(".chestpocket_hide_option.is-selected").length > 0) {
          chestPocket.find(".chestpocket_hide_option.is-selected").removeClass("is-selected");
          chestPocket.find(".cm-drawer-container").not(".chestpocket_hide_option").eq(0).addClass("is-selected");
          setTimeout(() => {
            let newTxt = chestPocket.find(".is-selected .cm-drawer-title strong").text();
            thisObj.find(".cm-navigation-middle .isSelected .chest_pocket .cm-modifier-result-name .cm-modifier-result-title").text(newTxt);
          },100);
        }
        chestPocket.find(".chestpocket_hide_option").hide();
      }else{
        chestPocket.find(".chestpocket_hide_option").show();
      }
  
      selectedTitleDown == 'fabric' ? thisObj.find(".cm-navigation-middle .isSelected .lining_color").hide() :
        thisObj.find(".cm-navigation-middle .isSelected .lining_color").show();
    }
    /* End Waistcoat tab option hide show */

    /* Waistcoat Add or not */
    if(thisObj.find(".cm-navigation-middle .isSelected").data("progress") == 'waistcoat-design' 
       && thisObj.find(".cm-navigation-middle .isSelected .cm-modifier-card-container").eq(0).find(".cm-modifier-card-content").hasClass("active-option")){
        
      if($(this).parents(".cm-modifier-drawer.isSelected").find(".is-selected").hasClass("add_waistcoat") 
        && thisObj.find(".cm-navigation-middle .isSelected[data-progress='waistcoat-design']").find(".cm-modifier-disable").length > 0){

        thisObj.find(".cm-navigation-middle .isSelected .cm-modifier-card-list .cm-modifier-disable").removeClass("cm-modifier-disable");
        thisObj.find(".cm-navigation-middle .isSelected").removeClass("cm-waistcoat-disabled");
        $(".sz-ppt-main").find(".sz-ppt-progress-container[data-id='my-passport-detail'] .sz-ppt-mybox-wrapper[data-type='waistcoat-passport']").removeClass("hide");
        $(".sz-ppt-main").find(".sz-ppt-progress-container[data-id='my-passport-detail']").find(".sz-ppt-footer-popup .add-to-cart-passport").addClass("disabled");
        thisObj.find(".cm-navigation-middle .cm-progress-container[data-progress='checkout']").find(".is_waistcoat_option").removeClass("hide");
        
        // Show price input box for custom fabric when add waistcoat (staff member only)
        if($(".cm-progress-container[data-progress='fabric-choice']").find(".cstm-fab-item.active").length > 0) {
          $(this).parents(".isSelected").find(".cm-drawer-cstm-fab-option").addClass("active");
          $(this).parents(".isSelected").find(".cm-drawer-cstm-fab-option").find(".cstm-fab-wstct-price").focus();
          thisObj.find(".cm-navigation-middle .isSelected").find(".cm-drawer-cstm-fab-option").addClass("active");
        }

      } else if($(this).parents(".cm-modifier-drawer.isSelected").find(".is-selected").find(".cm-drawer-title strong").text().toLowerCase().includes('no')){
        
        if(!thisObj.find(".cm-navigation-middle .isSelected").hasClass("cm-waistcoat-page")){
          thisObj.find(".cm-navigation-middle .isSelected").addClass("cm-waistcoat-disabled");
          thisObj.find(".cm-navigation-middle .isSelected .cm-modifier-card-list .cm-modifier-card-container").filter(function(index){
            return index > 0;
          }).addClass("cm-modifier-disable");

          $(".sz-ppt-main").find(".sz-ppt-progress-container[data-id='my-passport-detail'] .sz-ppt-mybox-wrapper[data-type='waistcoat-passport']").addClass("hide");
          $(".sz-ppt-main").find(".sz-ppt-progress-container[data-id='my-passport-detail']").find(".sz-ppt-footer-popup .add-to-cart-passport").removeClass("disabled");
          thisObj.find(".cm-navigation-middle .cm-progress-container[data-progress='checkout']").find(".is_waistcoat_option").addClass("hide");

          // Hide price input box for custom fabric when add waistcoat (staff member only)
          if($(".cm-progress-container[data-progress='fabric-choice']").find(".cstm-fab-item.active").length > 0) {
            $(this).parents(".isSelected").find(".cm-drawer-cstm-fab-option").removeClass("active");
            thisObj.find(".cm-navigation-middle .isSelected").find(".cm-drawer-cstm-fab-option").removeClass("active");
          }
        }

      }
    }
    /* End Waistcoat Add or not */


    /* Coat option */
    if(thisObj.find(".cm-navigation-middle .isSelected").data("progress") == 'coat-design'){
      /* Raglan coat tab option hide show */
      if(thisObj.find(".cm-navigation-middle .isSelected").data("block") == 'raglan-coats' && 
        thisObj.find(".cm-navigation-middle .isSelected .active-option").parents(".clicked_option").length > 0){
          let liningOpt = thisObj.find(".cm-navigation-middle .isSelected .lining_option .cm-data-content");
          liningOptVal = liningOpt.find(".is-selected .cm-drawer-title strong").text().trim().toLowerCase();
          if(liningOptVal == 'unlined') {
            thisObj.find(".cm-navigation-middle .isSelected .lining_color").hide();
          } else {
            thisObj.find(".cm-navigation-middle .isSelected .lining_color").show();
          }
      }
      /* End Raglan coat tab option hide show */

      /* Overcoat tab option hide show */
      if(thisObj.find(".cm-navigation-middle .isSelected").data("block") == 'overcoat' && 
        thisObj.find(".cm-navigation-middle .isSelected .active-option").parents(".clicked_option").length > 0){
        let lapelOption = thisObj.find(".cm-navigation-middle .isSelected .lapel_style .cm-data-content");
        let invertedBoxPleat = thisObj.find(".cm-navigation-middle .isSelected .inverted_box_pleat .cm-data-content");
        let martingaleBelt = thisObj.find(".cm-navigation-middle .isSelected .martingale_belt .cm-data-content");
        let vent = thisObj.find(".cm-navigation-middle .isSelected .vent_cls .cm-data-content");
        let chestPocket = thisObj.find(".cm-navigation-middle .isSelected .chest_pocket .cm-data-content");
        let sidePocket = thisObj.find(".cm-navigation-middle .isSelected .side_pocket .cm-data-content");
        let sleeveDesign = thisObj.find(".cm-navigation-middle .isSelected .sleeve_design .cm-data-content");
        let amf = thisObj.find(".cm-navigation-middle .isSelected .amf_cls .cm-data-content");
        let buttonholeBody = thisObj.find(".cm-navigation-middle .isSelected .buttonhole_body .cm-data-content");

        // hide/show notch peak lapel style
        if(selectedTitleDown.includes("single breasted:")){
          hideShowOption (thisObj, lapelOption, '.notch_peak_option', 'lapel_style');
        }
        
        // hide/show notch lapel style
        if(selectedTitleDown.includes("double breasted")){
          hideShowOption (thisObj, lapelOption, '.notch_option', 'lapel_style');
        }

        // hide/show no option from Inverted Box Pleat
        if(selectedTitleDown.includes("notch peak") || lapelOption.find(".is-selected .cm-drawer-title strong").text().trim().toLowerCase() == 'notch peak'){
          //hideShowOption (thisObj, invertedBoxPleat, '.no_pleat_option', 'inverted_box_pleat');
          hideShowOption (thisObj, chestPocket, '.none_option', 'chest_pocket');
          hideShowOption (thisObj, sidePocket, '.side_pockets_hide_options', 'side_pocket');
          hideShowOption (thisObj, sleeveDesign, '.uncuffed_option', 'sleeve_design');
          hideShowOption (thisObj, amf, '.6_mm_option', 'amf_cls');
        } else {
          invertedBoxPleat.find(".cm-drawer-container").show();
          chestPocket.find(".cm-drawer-container").show();
          sidePocket.find(".cm-drawer-container").show();
          sleeveDesign.find(".cm-drawer-container").show();
          amf.find(".cm-drawer-container").show();
          /*setTimeout(() => {
            let ibp = invertedBoxPleat.find(".is-selected .cm-drawer-title strong").text();
            thisObj.find(".cm-navigation-middle .isSelected .inverted_box_pleat .cm-modifier-result-name .cm-modifier-result-title").text(ibp);

            let cp = chestPocket.find(".is-selected .cm-drawer-title strong").text();
            thisObj.find(".cm-navigation-middle .isSelected .chest_pocket .cm-modifier-result-name .cm-modifier-result-title").text(cp);

            let sp = sidePocket.find(".is-selected .cm-drawer-title strong").text();
            thisObj.find(".cm-navigation-middle .isSelected .side_pocket .cm-modifier-result-name .cm-modifier-result-title").text(sp);

            let sd = sleeveDesign.find(".is-selected .cm-drawer-title strong").text();
            thisObj.find(".cm-navigation-middle .isSelected .sleeve_design .cm-modifier-result-name .cm-modifier-result-title").text(sd);

            let amfval = amf.find(".is-selected .cm-drawer-title strong").text();
            thisObj.find(".cm-navigation-middle .isSelected .amf_cls .cm-modifier-result-name .cm-modifier-result-title").text(amfval);
          },100);*/
        }

        if(invertedBoxPleat.find(".is-selected .cm-drawer-title strong").text().trim().toLowerCase() == 'yes'){
          hideShowOption (thisObj, martingaleBelt, '.no_belt_option', 'martingale_belt');
        }else{
          martingaleBelt.find(".no_belt_option").show();
        }

        if(martingaleBelt.find(".is-selected .cm-drawer-title strong").text().trim().toLowerCase() == 'no'){
          hideShowOption (thisObj, vent, '.single_with_button_option', 'vent_cls');
        }else{
          vent.find(".single_with_button_option").show();
        }
        
        let btnHoleBodyVal = buttonholeBody.find(".is-selected .cm-drawer-title strong").text().trim().toLowerCase();
        if(btnHoleBodyVal == 'traditional') {
          hideShowOption (thisObj, thisObj.find(".cm-navigation-middle .isSelected .buttonhole_lapel .cm-data-content"), '.handmade_option', 'buttonhole_lapel');
        } else {
          thisObj.find(".cm-navigation-middle .isSelected .buttonhole_lapel .cm-data-content").find(".handmade_option").show();
        }
      }
      /* End Overcoat tab option hide show */
    }

    // When custom fabric waistcoat price not added or 0 added (staff member)
    if(checkCustomFabWaistcoatPrice($(this)) == false) {
      return;
    }

    updatePrice();  // Update price

    if(typeof event.isTrigger == 'undefined'){
      var $cardContainer = $(this).parents(".cm-navigation").find(".cm-navigation-middle .isSelected").find(".active-option").parents(".cm-modifier-card-container");
      var $nextEle = $cardContainer.nextAll(":not([style*='display: none'])").first();
      var $cmModifierCardContent = $nextEle.find(".cm-modifier-card-content");

      if($cmModifierCardContent.attr("data-drawer") != 'one'){
        setTimeout(() => {
          $(this).parents(".cm-navigation").find(".cm-modifier-drawer[drawer-type='one']").removeClass("isSelected");
        }, 500);
      }

      if(thisObj.find(".cm-navigation-middle .isSelected").data("progress") == 'waistcoat-design' && (thisObj.parents("body").attr("data-page") == 'custom-made-suit' || thisObj.parents("body").attr("data-page") == 'custom-made-tuxedo-suit')) {
        if(thisObj.find(".cm-navigation-middle .isSelected").find(".cm-data-content.waistcoat_drawer").find(".is-selected.add_waistcoat").length > 0){
          $nextEle.find(".cm-modifier-card-content").trigger("click");
        } else{
          $(this).parents(".cm-modifier-drawer").removeClass("isSelected");
        }
      }else {
        $nextEle.find(".cm-modifier-card-content").trigger("click"); 
      }

      if($nextEle.length == 0) {
        if(thisObj.find(".cm-navigation-middle .cm-progress-container.isSelected").hasClass("back_checkout")){
          $(".btm_tab").find(".cm-toggle-item[data-id='checkout']").trigger("click");
        }
      }
      return;
    }

    /* Change design images on select previous design options */
      let currOpt = $(".active-option").find(".cm-modifier-col-title").text().toLowerCase();
      renderOptionImages(currOpt, selectedTitleDown);
  });

  /* Change design images */
  function renderOptionImages(currOpt, selectedTitleDown) {
    $(".cm-progress-container.isSelected .cm-modifier-card-container").each(function () {
      const $container = $(this);
      const optionName = $container.attr("name");
      const currOptName = $container.find(".is-selected .cm-drawer-title strong").text().toLowerCase();
      const config = dependentOptionsJSON?.[optionName]?.[currOptName];

      if(config){
        Object.keys(config).forEach(label => {
          let clickedOpt = $(".cm-progress-container.isSelected").find(".cm-modifier-card-container[name='"+label+"']");
          const options = config[label];
          if (!Array.isArray(options)) return;

          options.forEach(opt => {
            if(opt.image) {
              clickedOpt.find(".cm-data-content").find("img[name='"+opt.label.toLowerCase()+"']").attr("src", opt.image);
            }
          });
        });
      }
    });
  }


  //initializeOptionImagesOnLoad();
  function renderOptionImagesReactive(optionName, selectedLabel) {

    if (!optionName || !dependentOptionsJSON[optionName]) return;

    const configData = dependentOptionsJSON[optionName];
    selectedLabel = selectedLabel?.toLowerCase()?.trim();

    /* -----------------------------
      DIRECT ARRAY STRUCTURE
    ------------------------------ */
    if (Array.isArray(configData)) {

      const $container = $(".cm-modifier-card-container[name='" + optionName + "']");

      configData.forEach(opt => {
        if (!opt.image) return;

        $container
          .find("img[name='" + opt.label.toLowerCase() + "']")
          .attr("src", opt.image);
      });

      return;
    }

    /* -----------------------------
      NESTED STRUCTURE
    ------------------------------ */

    const nestedConfig = configData[selectedLabel];
    if (!nestedConfig) return;

    Object.keys(nestedConfig).forEach(childOptionName => {

      const childOptions = nestedConfig[childOptionName];
      if (!Array.isArray(childOptions)) return;

      const $childContainer = $(".cm-modifier-card-container[name='" + childOptionName + "']");

      childOptions.forEach(opt => {
        if (!opt.image) return;

        $childContainer
          .find("img[name='" + opt.label.toLowerCase() + "']")
          .attr("src", opt.image);
      });

    });

  }

  function initializeOptionImagesOnLoad() {
    $(".cm-progress-container.isSelected .cm-modifier-card-container").each(function () {
      const $container = $(this);
      const optionName = $container.attr("name");

      if (!dependentOptionsJSON[optionName]) return;
      const selectedLabel = $container.find(".is-selected .cm-drawer-title strong").text().toLowerCase().trim();
      if (selectedLabel) {
        renderOptionImagesReactive(optionName, selectedLabel);
      }
    });
  }
  /* END DRAWER 1, 3, 5 */

  
  /* DRAWER 2 */
  // Select option from drawer
  $(document).on("click", ".cm-modifier-drawer[drawer-type='two'] .cm-drawer-list .cm-drawer-container", function(){
    $(this).parents(".cm-modifier-drawer-wrap").find(".cm-drawer-container.is-selected").removeClass("is-selected");
    $(this).addClass("is-selected");
    $(this).parents(".cm-modifier-drawer[drawer-type='two']").find(".cm-modifier-drawer-bottom").find(".drawer2_apply").addClass("inactive_button");

    // Hide 'Other' option when click on options (excepted other option (staff member))
    if($(this).parent(".cm-drawer-other-option").length == 0){
      $(this).parents(".cm-modifier-drawer-wrap").find(".cm-drawer-other-option.active").removeClass("active");
    }

    document.body.classList.add("line-loading-3d-preview");
    setTimeout(() => {
      $(this).parents(".cm-modifier-drawer[drawer-type='two']").find(".cm-modifier-drawer-bottom").find(".drawer2_apply").trigger("click");
    }, 100);
  });

  // Apply selected button
  $(document).on("click", ".cm-modifier-drawer[drawer-type='two'] .drawer2_apply", function(event){

    if(typeof event.isTrigger == 'undefined'){
      var $cardContainer = $(this).parents(".cm-navigation").find(".cm-navigation-middle .isSelected").find(".active-option").parents(".cm-modifier-card-container");
      var $nextEle = $cardContainer.nextAll(":not([style*='display: none'])").first();
      var $cmModifierCardContent = $nextEle.find(".cm-modifier-card-content");

      if($cmModifierCardContent.attr("data-drawer") != 'two'){
        setTimeout(() => {
          $(this).parents(".cm-navigation").find(".cm-modifier-drawer[drawer-type='two']").removeClass("isSelected");
        }, 500);
      }
      $nextEle.find(".cm-modifier-card-content").trigger("click"); 

      if($nextEle.length == 0) {
        if($(this).parents(".cm-navigation").find(".cm-navigation-middle .cm-progress-container.isSelected").hasClass("back_checkout")){
          $(".btm_tab").find(".cm-toggle-item[data-id='checkout']").trigger("click");
        }
      }
      return;
    }
    
    let selectedTitle = $(this).parents(".cm-modifier-drawer.isSelected").find(".is-selected .cm-drawer-content strong").text();
    $(this).parents(".cm-navigation").find(".cm-navigation-middle .isSelected .active-option .cm-modifier-result-title").text(selectedTitle);
    
    let newHTML = $(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-wrap").html();
    $(this).parents(".cm-navigation").find(".isSelected .active-option").parents(".cm-modifier-card-container").find(".cm-data-content").html(newHTML);
    updatePrice();
  });
  /* END DRAWER 2 */

  
  /* DRAWER 4 */
  // Select option
  $(document).on("click", ".cm-modifier-drawer[drawer-type='four'] .cm-drawer-list .cm-drawer-container", function(){
    let drawerStep = $(this).parents(".cm-modifier-drawer-wrap").attr("drawer-step");
    //if(!$(this).parents(".cm-modifier-drawer-wrap").hasClass("cm-shirt-page")){
    $(this).parents(".cm-modifier-drawer-wrap").find(".cm-drawer-container.is-selected").removeClass("is-selected");
    //}
    $(this).addClass("is-selected");

    // Hide other option when click on another design options (excepted other option (staff member))
    if($(this).parent(".cm-drawer-other-option").length == 0){
      $(this).parents(".cm-modifier-drawer-wrap").find(".cm-drawer-other-option.active").removeClass("active");
    }
    
    if(drawerStep == 1){
      if(!$(this).hasClass("option-none")){
        $(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-bottom .btn-customize").not(".close_btn").val("Next");
        $(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-bottom .btn-customize").not(".close_btn").addClass("drawer-four-next-btn");
      }else{
        //$(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-bottom .btn-customize").not(".close_btn").val("Apply");
        $(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-bottom .btn-customize").not(".close_btn").val("Next");
        $(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-bottom .btn-customize").not(".close_btn").removeClass("drawer-four-next-btn");
      }
    }else if(drawerStep == 3 || drawerStep == 4){
      $(this).closest(".cm-modifier-drawer").find(".cm-modifier-drawer-bottom .drawer-four-next-btn").prop("disabled", false);
      if(drawerStep == 4){
        //$(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-bottom .btn-customize").not(".close_btn").val("Apply");
        $(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-bottom .btn-customize").not(".close_btn").val("Next");
        $(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-bottom .btn-customize").not(".close_btn").removeClass("drawer-four-next-btn");
      }else{
        //$(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-bottom .btn-customize").not(".close_btn").val("Next");
        //$(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-bottom .btn-customize").not(".close_btn").addClass("drawer-four-next-btn");
      }
    }
  });

  // Apply button
  $(document).on("click", ".cm-modifier-drawer[drawer-type='four'] .apply_btn", function(event){
    let allSelectedVal = [];
    
    if(!$(this).hasClass("drawer-four-next-btn") && !$(this).parent(".cm-add-btns").find(".close_btn").hasClass("back_btn")){
      $(this).parent(".cm-add-btns").find(".close_btn").click();
      $(this).parents(".cm-navigation").find(".cm-navigation-middle .isSelected .active-option .cm-modifier-result-title").text('No');
      
      $(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-wrap[drawer-step=2] .monogram_input").attr('value', '');
      $(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-wrap[drawer-step=3] .is-selected").removeClass("is-selected");
      $(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-wrap[drawer-step=4] .is-selected").removeClass("is-selected");
    }else if(!$(this).hasClass("drawer-four-next-btn") && $(this).parent(".cm-add-btns").find(".close_btn").hasClass("back_btn")){
      $(this).closest(".cm-modifier-drawer").removeClass("isSelected");
        
      if($(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-wrap[drawer-step=1] .is-selected").length > 1){
        var multiVal = [];
        $(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-wrap[drawer-step=1] .is-selected").each(function(){
          multiVal.push($(this).find(".cm-drawer-title strong").text());
        });
        allSelectedVal.push(multiVal.join(","))
      }else{
        if($(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-wrap[drawer-step=1]").find(".cm-drawer-other-option").hasClass("active")){
          allSelectedVal.push($(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-wrap[drawer-step=1]").find(".cm-drawer-other-option .other-option").val().trim());
        } else {
          allSelectedVal.push($(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-wrap[drawer-step=1] .is-selected .cm-drawer-title strong").text());
        }
      }
      
      allSelectedVal.push($(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-wrap[drawer-step=2] .monogram_input").val());

      if($(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-wrap[drawer-step=3]").find(".cm-drawer-other-option").hasClass("active")){
        allSelectedVal.push($(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-wrap[drawer-step=3]").find(".cm-drawer-other-option .other-option").val().trim());
      } else {
        allSelectedVal.push($(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-wrap[drawer-step=3] .is-selected .cm-drawer-title strong").text());
      }

      if($(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-wrap[drawer-step=4]").find(".cm-drawer-other-option").hasClass("active")){
        allSelectedVal.push($(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-wrap[drawer-step=4]").find(".cm-drawer-other-option .other-option").val().trim());
      } else {
        allSelectedVal.push($(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-wrap[drawer-step=4] .is-selected .cm-drawer-title strong").text());
      }

      //allSelectedVal.push($(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-wrap[drawer-step=3] .is-selected .cm-drawer-title strong").text());
      //allSelectedVal.push($(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-wrap[drawer-step=4] .is-selected .cm-drawer-title strong").text());
      allSelectedVal = jQuery.grep(allSelectedVal, function(n){ return (n); });
      $(this).parents(".cm-navigation").find(".cm-navigation-middle .isSelected .active-option .cm-modifier-result-title").text(allSelectedVal.join(', '));
    }
    let drawer4NewHTML = $(this).parents(".cm-modifier-drawer").find(".cm-modifier-multidrawer-slidewrap").html();
    $(this).parents(".cm-navigation").find(".isSelected .active-option").parents(".cm-modifier-card-container").find(".cm-data-content").html(drawer4NewHTML);
    if($(this).parents(".cm-navigation").find(".cm-navigation-middle .cm-progress-container.isSelected").hasClass("back_checkout")){
      $(".btm_tab").find(".cm-toggle-item[data-id='checkout']").trigger("click");
    }
  });

  // Next button
  $(document).on("click", ".drawer-four-next-btn", function(){
    let declaration = parseInt(getComputedStyle(this.closest(".cm-modifier-drawer").querySelector(".cm-modifier-multidrawer-slidewrap")).getPropertyValue('--slider-current'));
    
    if(declaration < 3){
      this.closest(".cm-modifier-drawer").querySelector(".cm-modifier-multidrawer-slidewrap").style.setProperty('--slider-current', declaration+1);
      
      if(declaration == 0){
        if($(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-wrap[drawer-step='"+(declaration+2)+"']").find(".monogram_input").val() == ''){
          $(this).prop("disabled", true);
        }else{
          $(this).prop("disabled", false);
        }
      }else{
        if($(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-wrap[drawer-step='"+(declaration+2)+"']").find(".is-selected").length == 0){
          //$(this).prop("disabled", true);

          if($(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-wrap[drawer-step='"+(declaration+2)+"']").find(".cm-drawer-other-option").hasClass("active")) {
            if($(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-wrap[drawer-step='"+(declaration+2)+"']").find(".other-option").val() != '') {
              $(this).prop("disabled", false);
              if(declaration == 2){
                $(this).removeClass("drawer-four-next-btn");
              }
            } else {
              $(this).prop("disabled", true);
            }
          } else {
            $(this).prop("disabled", true);
          }

          if(!$(this).parents(".cm-modifier-drawer").find(".cm-modifier-drawer-wrap[drawer-step='"+(declaration+2)+"']").find(".other-option").val()) {
            $(this).prop("disabled", true);
          } else {
            $(this).prop("disabled", false);
            if(declaration == 2){
              $(this).removeClass("drawer-four-next-btn");
            }
          }
        }else{
          $(this).prop("disabled", false);
          if(declaration == 2){
            $(this).removeClass("drawer-four-next-btn");
          }
        }
      }
      $(this).parents(".cm-add-btns").find(".close_btn").addClass("back_btn");
    }
  });

  // Back button
  $(document).on("click", ".cm-modifier-drawer[drawer-type='four'] .back_btn", function(){
    var declaration = parseInt(getComputedStyle(this.closest(".cm-modifier-drawer").querySelector(".cm-modifier-multidrawer-slidewrap")).getPropertyValue('--slider-current'));
    if(declaration > 0){
      this.closest(".cm-modifier-drawer").querySelector(".cm-modifier-multidrawer-slidewrap").style.setProperty('--slider-current', declaration-1);
      $(this).parents(".cm-add-btns").find(".drawer-four-next-btn").prop("disabled", false);
      $(this).parents(".cm-add-btns").find(".apply_btn").val("Next");
      if(declaration == 1){
        $(this).removeClass("back_btn");
      }
    }
  });

  // Add monogram text
  $(document).on("keyup", ".monogram_input", function(){
    if($(this).val() != ''){
      $(this).closest(".cm-modifier-drawer").find(".cm-modifier-drawer-bottom .drawer-four-next-btn").prop("disabled", false);
      $(this).attr("value", $(this).val());
    }else{
      $(this).closest(".cm-modifier-drawer").find(".cm-modifier-drawer-bottom .drawer-four-next-btn").prop("disabled", true);
    }
  });
  /* END DRAWER 4 */

  // Close info drawer
  $(document).on("click", ".cm-full-mask", function(){
    $(this).removeClass("isShow");
    $(".cm-size-popup").hasClass("isSelected") ? $(".cm-size-popup").removeClass("isSelected") : null;
    $(".size-inpt-popup").hasClass("opened") ? $(".size-inpt-popup").removeClass("opened") : null;
  });

  //Add to cart
  $(document).on("click", ".cm-add-cart .add_to_cart_btn", function(){
    const thisObj = $(this);
    var currTime = $.now();
    $(".cm-navigation").find(".cm-progress-container.isSelected").find(".cm-modifier-card-list[data-tab-progress='size-meauserments']").find(".warning-msg").remove();
    
    if($(".cm-progress-container[data-progress='checkout'] .cm-main-sizes .cm-modifier-card-container").not(".hide").find(".err-cls").length > 0){
      if($(".sz-ppt-sb-panel").attr("data-staff-member") == "true"){
        $(".btm_tab").find(".cm-toggle-item[data-id='checkout']").trigger("click");
      }
      $(".cm-navigation-middle").animate({
        scrollTop: $(".cm-navigation-middle")[0].scrollHeight
      }, 1000);
      return false;
    }

    if($(".sz-ppt-sb-panel").attr("data-staff-member") == "true"){
      if($(document).find(".cm-uploaded-media-preview").find(".cm-preview-box").length > 0) {
        if($(document).find(".cm-uploaded-media-preview").find(".cm-preview-box").find(".cm-modifier-remove-btn").not(".hide").length > 0) {
          showMessage('Please upload selected images', 'error');
          return false;
        }
      }
    }

    const newArr = getAllProperties(thisObj);
    for(let i=0; i<newArr.length; i++) {
      Object.keys(newArr[i]['properties']).some(function (key) {
        const value = newArr[i]['properties'][key];

        if (key.includes('-uid') && value) hasUid = true;
        if (key.includes('_measurement_type') && value) hasMeasurementType = true;
        return hasUid && hasMeasurementType;
      });
    }
  
    //const $target = $(".cm-navigation").find(".cm-progress-container.isSelected").find(".cm-modifier-card-list[data-tab-progress='size-meauserments']") || $(".cm-navigation").find(".cm-progress-container.isSelected").find(".cm-modifier-upload-media-wrapper");

    const $container = $(".cm-navigation .cm-progress-container.isSelected");
    const $first = $container.find(".cm-modifier-card-list[data-tab-progress='size-meauserments']");
    const $target = $first.length ? $first : $container.find(".cm-modifier-upload-media-wrapper");

    if(!hasUid || !hasMeasurementType){
      $target.append('<span class="warning-msg">Required data not found: Passport ID or Measurement type. Please refresh the page.</span>');
      const $warningMsg = $target.find(".warning-msg")[0];
      const container = $(".cm-navigation-middle")[0];
      const containerTop = container.getBoundingClientRect().top;
      const elementTop = $warningMsg.getBoundingClientRect().top;
      const scrollTop = container.scrollTop + (elementTop - containerTop);

      container.scrollTo({
        top: scrollTop,
        behavior: "smooth"
      });
      return;
    }
    
    //return;
    if(newArr.length > 0){
      $("body").addClass("loading showOverly");
      function moveAlong(){
        var success_index = 0;
        if (newArr.length) {
          var array_length = newArr.length;
          var request = newArr.shift();
          var tempId= request.id;
          var tempQty = request.quantity;
          var prop = request.properties;
          prop['_time'] = currTime;
          
          CartJS.addItem(
            tempId,
            tempQty,
            prop,
            {
              success: function (data, textStatus, jqXHR) {
                success_index = success_index+1;
                setTimeout(function(){
                  moveAlong();
                }, 100);
                if(array_length == success_index){
                  if(document.querySelector('.cm-uploaded-media-preview')) {
                    document.querySelector('.cm-uploaded-media-preview').innerHTML = '';
                  }
                  if(document.querySelector('.cm-uploaded-media-preview-final')) {
                    document.querySelector('.cm-uploaded-media-preview-final').innerHTML = '';
                  }
                  getCartDrawer();
                  setTimeout(function () {
                    $("body").removeClass("loading showOverly");
                    $(".site-header__cart").trigger("click");
                    window.media = [];
                  }, 1000);
                }
              },
              error: function (jqXHR, textStatus, errorThrown) {
                var errormsg = JSON.parse(jqXHR.responseText).description;
                $("body").removeClass("loading");
                $(".error-message").text(errormsg);
                $("#errorDrawer").show();
                setTimeout(() => {
                  $("body").removeClass("showOverly");
                  $("#errorDrawer").hide();
                }, 5000);
              },
            }
          );
        }
      }
      moveAlong();
    }
   
  });
  
  // Get all properties data
  function getAllProperties(obj){
    var finalArr = [];
    var designProArr = [];
    var fabChoice = obj.parents(".cm-navigation").find(".cm-progress-container[data-progress='fabric-choice']");
    const fabTitle = obj.parents(".cm-navigation").find(".cm-progress-container[data-progress='checkout'] .fabric_summary h5").text();
    const fabVal = obj.parents(".cm-navigation").find(".cm-progress-container[data-progress='checkout'] .fabric_summary .cm-modifier-col-title").text();
    
    obj.parents(".cm-navigation").find(".cm-progress-container[data-progress='checkout'] .cm-main-checkout .cm-modifier-card-list").each(function(index){
      if($("body").hasClass("is_tuxedo_page")){
        //var mainTabTitle = "_tuxedo_"+$(this).find(".cm-checkout-heading").text();
        var mainTabTitle = "tuxedo_"+$(this).find(".cm-checkout-heading").text();
      }else{
        //var mainTabTitle = "_"+$(this).find(".cm-checkout-heading").text();
        var mainTabTitle = $(this).find(".cm-checkout-heading").text();
      }
      const varId = $(this).find(".cm-var-id").val();
      const curId = $(this).attr("data-tab-block");
      const proArr = {};
      const fabric_details = {};
      const design_details = {};
      const custom_fabric = {};

      index == 0 ? proArr['_is_first'] = 'true' : '';

      var isSuitPro = ['/pages/custom-made-suit'].includes(window.location.pathname);
      var isTuxedoSuitPro = ['/pages/custom-made-tuxedo-suit'].includes(window.location.pathname);

      if(isSuitPro) {
        index == 0 ? proArr['_is_suit'] = 'true' : '';
      }
      if(isTuxedoSuitPro) {
        index == 0 ? proArr['_is_tuxedo_suit'] = 'true' : '';
      }

      // design option products
      $(this).find(".is_product.is-selected .pro_option").each(function(){
        let propArr = {};
        let designProId = $(this).attr("data-var");
        let type = "_"+$(this).parents(".cm-modifier-card-list").find(".cm-checkout-heading").text();
        let designTitle = type+"("+$(this).parents(".cm-modifier-card-container").find(".cm-modifier-col-title").text()+")";
        let selectedVal = $(this).parents(".cm-modifier-card-container").find(".cm-modifier-result-title").text();
       
        if(designTitle && selectedVal){ propArr['_design_pro'] = 'true'; propArr[designTitle] = selectedVal; }
        
        if(designProId){
          designProArr.push({
            'id':designProId,
            'properties':propArr
          });
        }
      });

      // Add fabric details
      if(fabTitle && fabVal){
        fabric_details['Title'] = fabVal;
      }
      
      let fabData;
      if(fabChoice.find("fabric-list.is-selected").length > 0) {
        fabData = fabChoice.find("fabric-list.is-selected").find(".cm-pro-description tr");
      } else if(fabChoice.find(".cstm-fab-item.active").length > 0) {
        fabData = fabChoice.find(".cstm-fab-item.active").find(".cstm-fab-desc tr");
        fabric_details['MILL'] = fabChoice.find(".cstm-fab-item.active input[name='mill']").val();
        fabric_details['ARTICLE CODE'] = fabChoice.find(".cstm-fab-item.active input[name='article-code']").val();
      }

      fabData.each(function() {
        let key = $(this).find("td").eq(0).text();
        let value = $(this).find("td").eq(1).text();
        fabric_details[key] = value;
      });
      proArr['_fabric_details'] = fabric_details;

      // Add custom fabric price data in properties (When Staff member login)
      if(fabChoice.find(".cstm-fab-item.active").length > 0) {
        if($("body").attr("data-page") == 'custom-made-suit' || $("body").attr("data-page") == 'custom-made-tuxedo-suit') {
          if(curId == 'waistcoat' || curId == 'tuxedo-waistcoat'){
            custom_fabric['price'] = parseFloat($(this).find(".is_product.is-selected").find(".pro_option").val())/100;
          } else {
            // when current page is suit we need to set half half price (which added for custom fabric) for both jacket & trouser
            custom_fabric['price'] = parseFloat(fabChoice.find(".cstm-fab-item.active input[name='price']").val())/2;
          }
        } else {
          custom_fabric['price'] = fabChoice.find(".cstm-fab-item.active input[name='price']").val();
        }
        proArr['_custom_fabric'] = custom_fabric;
      }
      
      // Get design options 
      $(this).find(".cm-modifier-card-container").each(function(){
        if(!$(this).hasClass("cm-modifier-disable") && $(this).css('display') !== 'none'){
          let designTitle = $(this).find(".cm-modifier-col .cm-modifier-col-title").text().trim();
          if(designTitle.includes("+ Add") || designTitle.includes("+ add")){
            var title = mainTabTitle+"("+designTitle.replace("+ add ", "").replace("+ Add ", "")+")";
          }else{
            var title = mainTabTitle+"("+designTitle+")";
          }
          const val = $(this).find(".cm-modifier-result-name .cm-modifier-result-title").text().trim();
          if(title && val){
            design_details[title] = val;
          }
        }
      });
      
      // Get design option note (staff member)
      var modifierNote = $(this).find(".cm-modifier-note");
      if(modifierNote.length > 0 && modifierNote.find(".extra_note").val() != ''){
        design_details['note'] = modifierNote.find(".extra_note").val();
      }
      proArr['_design_details'] = design_details;

      if(curId == 'jacket'){
        if($("body").hasClass("is_tuxedo_page")){
          proArr['_measurement_type'] = 'custom_made_tuxedo_jacket_measurement'; 
        }else{
          proArr['_measurement_type'] = 'custom_made_jacket_measurement'; 
        }
      }else if(curId == 'trouser'){
        if($("body").hasClass("is_tuxedo_page")){
          proArr['_measurement_type'] = 'custom_made_tuxedo_trouser_measurement'; 
        }else{
          proArr['_measurement_type'] = 'custom_made_trouser_measurement';  
        }
      }else if(curId == 'waistcoat'){
        if($("body").hasClass("is_tuxedo_page")){
          proArr['_measurement_type'] = 'custom_made_tuxedo_waistcoat_measurement';
        }else{
          proArr['_measurement_type'] = 'custom_made_waistcoat_measurement';
        }
      }else if(curId == 'shirt'){
        proArr['_measurement_type'] = 'custom_made_shirt_measurement'; 
      }else if(curId == 'raglan-coats'){
        if($("body").hasClass("is_tuxedo_page")){
          proArr['_measurement_type'] = 'custom_made_tuxedo_raglan_coat_measurement'; 
        }else{
          proArr['_measurement_type'] = 'custom_made_raglan_coat_measurement'; 
        }
      }else if(curId == 'overcoat'){
        if($("body").hasClass("is_tuxedo_page")){
          proArr['_measurement_type'] = 'custom_made_tuxedo_overcoat_measurement'; 
        }else{
          proArr['_measurement_type'] = 'custom_made_overcoat_measurement'; 
        }
      }

      // Get size passport details
      $(".sz-ppt-progress-container[data-id='my-passport-detail']").find(".sz-ppt-middle .sz-ppt-mybox-wrapper").not(".hide").each(function(pptBox) {
        let key = "_"+$(this).attr("data-type");
        let passUId = $(this).find(".selected").parents(".sz-ppt-mybox").attr("data-key");
        if($(this).attr("data-type").includes(curId)){
          if(passUId){
            proArr[key+'-uid'] = passUId;
          }
        }
      });

      if(window.media.length > 0) {
        proArr['_uploaded_media'] = window.media;
      }

      if(varId){
        finalArr.push({
          'id':varId,
          'quantity':1,
          'properties':proArr
        });
      }
    });
    
    if(designProArr.length > 0){
      $.each(designProArr, function(ind, val){ finalArr.push(val); })
    }  
    return finalArr;
  }

  if($(".cm-navigation .cm-card-main").find(".next_url").length > 0){
    var totalTop = parseInt($(".cm-navigation .cm-card-main").find(".next_url").offset().top);
    var totalHeight = totalTop - parseInt($(window).height() - $(".cm-navigation-bottom").height());
  }
  
  infiniteScroll = function () {
    $(".cm-navigation-middle").scroll(function(event) {
      if($(".cm-navigation .cm-card-main").find(".next_url").length > 0){
        var nextURL = $(".cm-navigation .cm-card-main").find(".next_url").attr("href");
        var bottom = $(".cm-navigation .cm-card-main").find(".next_url").offset();
        var docTop = $(document).scrollTop() + $(window).height() - $(".cm-popup-footer").height();
        if (docTop > (bottom.top-20)) {
          $(".cm-navigation-middle").off("scroll");
          loadMoreFabrics(nextURL);
        }
      }
    });
  };
  infiniteScroll();
});

// Check empty value of custom fabric waistcoat price (staff member)
function checkCustomFabWaistcoatPrice (objThis) {
  if($(".cm-progress-container[data-progress='fabric-choice']").find(".cstm-fab-item.active").length > 0 && 
    objThis.parents(".cm-modifier-drawer.isSelected").find(".is-selected").hasClass("add_waistcoat")) {
    let price = objThis.parents(".isSelected").find(".cm-drawer-cstm-fab-option").find(".cstm-fab-wstct-price").val();
    if(price == 0 || price == '') {
      objThis.parents(".isSelected").find(".cm-drawer-cstm-fab-option").find(".cstm-fab-wstct-price").focus(); 
      return false;
    }
  }
  return true;
}

// UPDATE PRICE
function updatePrice(){
  var newPrice = 0;
  $(document).find(".glm-cm-panel").find(".cm-navigation .cm-navigation-middle .cm-progress-container").not("[data-progress='checkout']").find(".is_product.is-selected").each(function(){
    newPrice = parseFloat(newPrice + parseFloat($(this).find(".pro_option").val()));
  });

  // Custom fabric price (only for Staff member login)
  if ($(".glm-cm-panel .cm-progress-container[data-progress='fabric-choice']").find(".cstm-fab-item.active").length > 0) {
    var fabPrice = parseFloat($(".glm-cm-panel").find(".cstm-fab-item.active").find("input[name='price']").val())*100;
    //console.log('fabric price', fabPrice);
    newPrice = parseFloat(newPrice + fabPrice);
  }
  //console.log('newPrice', newPrice);
  $(".cm-main").find(".cm-navigation-bottom .price").text(Shopify.formatMoney(parseFloat(newPrice)), Shopify.money_format);
}

function loadMoreFabrics(url){
  $.ajax({
    type: "GET",
    dataType: "html",
    url: url,
    beforeSend: function () {
      $(".load_more_product .ld-hydrated").css("display", "flex");
    },
    success: function(data){
      $(".cm-navigation .cm-card-main").find(".cm-card-list").append($(data).find(".cm-card-main .cm-card-list").html());
      if($(data).find(".cm-card-main .load_more_product").length > 0){
        $(".cm-card-main .load_more_product").html($(data).find(".cm-card-main .load_more_product").html());
      }else{
        $(".cm-card-main .load_more_product").remove();
      }
      $(".load_more_product .ld-hydrated").css("display", "none");
      infiniteScroll();
    }
  });
}

// Check empty input box value
function checkEmptyValNew(obj, id, callback){
  if(typeof id !== 'undefined' || id != ''){
    obj.parents(".cm-size-tabs-wrapper").find("#"+id).find(".cmsize-info-input").not(".hide").find(".outer_box .input_bx_cls").each(function(){
      var curVal = $(this).val();
      if(curVal == '' || curVal <= 0){
        $(this).parent(".outer_box").addClass("err-cls");
        $(this).parents(".cmsize-info-input").removeClass("opacity_cls");
        $(this).focus();
        callback(false);
        return false;
      }else{
        $(this).parent(".outer_box").removeClass("err-cls");
      }
    });
  }
}

function formatDecimal(input) {
  // Format the input to allow only one dot (decimal point)
  input.value = input.value.replace(/[^0-9.]/g, ''); // Remove non-numeric and non-dot characters
  const dotCount = (input.value.match(/\./g) || []).length;
  if (dotCount > 1) {
    // If there is more than one dot, remove the extra ones
    input.value = input.value.replace(/\.+$/, '');
  }
}

/* Hide/Show options based on another option value */
function hideShowOption($this, mainDiv, optionCls, mainCls) {
  mainDiv.find(".cm-drawer-container").show();
  if(mainDiv.find(optionCls).hasClass("is-selected")){
    mainDiv.find(optionCls).removeClass("is-selected");
    mainDiv.find(".cm-drawer-container").not(optionCls).eq(0).addClass("is-selected");
    setTimeout(() => {
      let newTxt = mainDiv.find(".is-selected .cm-drawer-title strong").text();
      $this.find(".cm-navigation-middle .isSelected ."+mainCls+" .cm-modifier-result-name .cm-modifier-result-title").text(newTxt);
    },100);
  }
  mainDiv.find(optionCls).hide();
}